import {
  Component,
  OnInit,
  HostListener,
  AfterViewInit,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  Renderer2,
} from '@angular/core';
declare function CallTrack_function(page,RepName,ProductName,terms, usage500, usageObj1000, usage2000, zipcode, utility_name,enrollmentStatus,Email): void;
declare function generateTooltip(): void;
import { Chart, StockChart } from 'angular-highcharts';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { RecommendationService } from './../recommendation.service';
import * as _ from 'underscore';
import * as Highcharts from 'highcharts';
import { Router , NavigationEnd } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import * as $ from 'jquery';
//declare var $;
import { ResidentialService } from '../../residential.service';
Highcharts.setOptions({ lang: { thousandsSep: ',' } });
import { NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import {
  ScrollToService,
  ScrollToConfigOptions,
} from '@nicky-lenaers/ngx-scroll-to';
import { BsModalRef, BsModalService, TabHeadingDirective } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { Window } from 'selenium-webdriver';
import { ThrowStmt } from '@angular/compiler';
import { PlatformLocation } from '@angular/common';
@Component({
  selector: 'app-compare-product',
  templateUrl: './compare-product.component.html',
  styleUrls: ['./compare-product.component.css'],
})
export class CompareProductComponent implements OnInit, AfterViewInit {
  // API Url
  url = environment.api_url;
  app_url = environment.aap_url;
  Math: any;
  idName: any;
  visibleCount = 3; // Initially show 3 plans
  // For highcharts
  Highcharts = Highcharts;
  productListOptions;
  highChartsOptions;
  updateValue = false; // optional boolean
  updateProductChart = false;
  cloneToolTip = null;
  // For click event
  DELAY = 700;
  clicks = 0;
  timer = null;
  showDetal = false;
  Ismobileview = false;
  showAll = false;
  recommendationObj;
  recommendProduct;
  splitData = [];
  chart;
  productList;
  productPriceList;
  selectedProduct = 0;
  ssnFailedTxt;
  ssnFailedEnergyProvidersList;
  selectedProductValue;
  oldValue;
  oldEGValue;
  olpercentage= 0;
  newValue;
  avgMthlyUsage;
  updatedNewValue;
  monthName;
  selectedIndex;
  showOption = false;
  ShowUpdatedUsage = false;
  productIndex = 0;
  temporarySplit = [];
  pointWidth = 35;
  accountId;
  maxAveragePriceObj;
  maxMonthlyBillObj;
  maxAveragePrice;
  maxMonthlyBill;
  option1 = false;
  option2 = false;
  option3 = false;
  option4 = false;
  option5 = false;
  option6 = false;
  dropDownValue;
  checkup = false;
  monthactive = 'Januarytrue';
  // Session storage
  residentialResponses = [];
  questionsArrayData = [];

  name = 'Sam Khavari';
  display = 'none';
  display1 = 'none';
  scrollActiveIndex;
  eventText;
  leftyarrow = false;
  rightyArrow = true;
  selectedTerm;
  seeDetailShow = false;

  showheader = false;
  // Mobile view dropdown slide.
  state = 0;
  OldEG_ = 0;
  maxState = 1;
  winWidth = $(window).width();
  divgdg = null;
  htmlElmScroll;
  scrollPosition = 0;
  topValue;
  editoption = true;
  monthlyUsageArr = [];
  showUndo = false;
  showUpdate = false;
  addSeeDetailsBorder = false;
  selectHeading = '';
  visibleGraph;
  graphSelectedProduct;
  deviceWidth;
  energyProviderList;
  checkedList = [];

  isDoneClicked = false;
  checkedListFinal = [];
  activeIdx = 0;
  hiddenProviders = [];
  recommendations = [];
  dropDownValues = [];
  ProductTypeSelectList = [];
  selectTerm = false;
  lastUncheck;
  lastUncheckProvider;
  swipedId;
  math = Math;
  label = '';
  avgKwhValue;
  avg_price_kwh;
  iskwh = false;
  user_bot = false;
  isEnabled;
  allRecommendations = [];
  prerecommendation: any;
  placeholder = 'Enter $0.XXX per kWh';
  hideAlll = false;
  renewableEnergyValue2;
  renewableEnergyValue1;
  prepaidwb2;
  prepaidwb1;
  renewablemb2;
  renewablemb1;
  noproductData = '';
  noresult = '';
  noproduct = false;
  prepaidb22;
  prepaidmb11;
  prepaidmobilee;
  scrollofChart = false;
  graaphLabelName;
  noproductdata;
  modalRef: BsModalRef;
  @ViewChild('newEnergyRates', { static: true }) newEnergyRates: ElementRef;
  @ViewChild('noofferPopup', { static: true }) noofferPopup: ElementRef;
  @ViewChild('earlyCancellationPopup', { static: true })
  earlyCancellationPopup: ElementRef;
  @ViewChild('planDetailsPopup', { static: true }) planDetailsPopup: ElementRef;
  ngbModalOptions: NgbModalOptions = {
    backdrop : 'static',
    keyboard : false
  };
  productSelection = false;
  cancellationValue: any;
  showFilters = false;
  showFirstCard = false;
  loadProductTypes = [
    { key: 'Fixed/Secured Rate', value: 'Fixed', checked: false },
    { key: 'Variable/No Contract', value: 'Variable', checked: false },
    { key: 'Prepaid/No Deposit', value: 'Prepaid', checked: false },
    { key: '100% Renewable', value: '100', checked: false },
    { key: 'Show All', value: 'ShowAll', checked: false },
  ];
  loadAvgUsages = [
    { key: '500 kWh (Apartment)', value: '500', checked: false, title:'Small Home', des:'500 kWh' },
    { key: '1000 kWh (Sm Home)', value: '1000', checked: false, title:'Medium Home', des:'1000 kWh' },
    { key: '2000 kWh (Lg Home)', value: '2000', checked: false, title:'Large Home', des:'2000 kWh' },
    { key: 'Custom Usage', value: 'Custom', checked: false, title:'Enter Usage History', des:'_____ kWh' },
  ];
  private loadEnergyProviders = {
    ProntoPower: this.navigatePrePaidEnergyProvider.bind(this),
    PulsePower: this.navigateOtherEnergyProviders.bind(this),
    NewPowerTexas: this.navigateOtherEnergyProviders.bind(this),
    ChariotEnergy: this.navigateOtherEnergyProviders.bind(this),
    Bulb: this.navigateBulbEnergyProvider.bind(this),
    ChangeEnergy4: this.navigateOtherEnergyProviders.bind(this),
    GexaEnergy: this.navigateOtherEnergyProviders.bind(this),
    FrontierUtilities: this.navigateOtherEnergyProviders.bind(this),
    TexpoEnergy: this.navigateOtherEnergyProviders.bind(this),
    RhythmEnergy: this.navigateOtherEnergyProviders.bind(this),
    BKVEnergy: this.navigateOtherEnergyProviders.bind(this),
    APGEEnergy: this.navigateOtherEnergyProviders.bind(this),
    ShellEnergy: this.navigateOtherEnergyProviders.bind(this),
    EnergyTexas: this.navigateOtherEnergyProviders.bind(this),
  };
  private loadContractTermsDetails = {
    Webview: this.setWebSelectedContractTerm.bind(this),
    mobileview: this.setMobileSelectedContractTerm.bind(this),
  };
  termId: any;
  getUniqueEnergyProvider = [];
  avgCharge500: any;
  avgCharge1000: any;
  avgCharge2000: any;
  recommendedEnergyCharge: any;
  recommendedBaseFee: any;
  recommendedTduCharge: any;
  monthlyEstimates = [];
  recommendedTduDeliveryCharge: any;
  productKeyTitle: string;
  averageMonthlyUsage: any;
  avgPricePerKWH: any;
  avgMonthlyBill: any;
  recommendedUsageCreditLimit: string;
  recommendedUsageCreditFee: any;
  recommendedBaseUsageLimit: any;
  private loadProductActionValues = {
    Fixed: this.setFixedValueProductType.bind(this),
    Variable: this.setVariableValueProductType.bind(this),
    Show: this.setShowValueProductType.bind(this),
  };
  productTitle: any;
  renewableEnergyValue3: boolean;
  setPrePaidValueProductType: any;
  prepaidwb4: boolean = false;
  hideFreezeopt = true;
  prepaidwb3: boolean;
  providersCount: number;
  utilityName: any;
  showSingleObjDetails = false;
  onload = true;
  productTypes = [];
  avgValueChanged: any;
  currentPage: number = 0;
  preSelectedRecords: any[];
  openIndex: number;
  globaloffset;
  PlanCardheight;
  // display = 'none';
  private unSubscribe = new Subject<void>();
  usage4CEObj: {
    // baseFee: any;
    // billCredit: any;
    usageValue: any;
    addUsageValue: any;
  };
  private history: string[] = []
  
  // Swipe left and right in Other plans.
  constructor(
    private _renderer2: Renderer2,
    private http: HttpClient,
    private recommendationService: RecommendationService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private residentialService: ResidentialService,
    private _scrollToService: ScrollToService,
    private cd: ChangeDetectorRef,
    private modalService: BsModalService,
    private location_: PlatformLocation  
  ) {

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects)
      }
    })
   
  }


  loadMore() {
    this.visibleCount += 3; // Increase the number of visible plans by 3
    setTimeout(function(){


      window.dispatchEvent(new Event('resize'));

    },100)
  }

  back_(): void {
    this.history.pop()
    if (this.history.length > 0) {
      this.location_.back()
    } else {
      this.router.navigateByUrl('/')
    }
  }
  onKey(event, index) {
    this.showUndo = true;
    this.showUpdate = true;
    this.monthlyUsageArr[index].usage = event.target.value;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {

    // $(window).scrollTop(0);
    // To set the chart width based on the sceen resolution
    if (window.screen.availWidth <= 595) {
      this.highChartsOptions.plotOptions.series.pointWidth = 22;
      this.updateValue = true;
    } else {
      this.highChartsOptions.plotOptions.series.pointWidth = 35;
      this.updateValue = true;
    }
    this.deviceWidth = window.innerWidth;
    if(this.deviceWidth < 1025)
    {
      this.hideFreezeopt = false;
      //$(".product-list").css("padding-top", 0)
    }else
    {
      //location.reload();
      this.hideFreezeopt = true;
      // if($('.chartfixedForScroll').length != 0 && $('#chartfixed').css('top') == "0px")
      // {
      //   $(".product-list").css("padding-top", $("#chartfixed").height())
  
      // }else
      // {
      //   $(".product-list").css("padding-top", 0)
      // }
    }

   
    this.fixChartSizePerResolution();

    // Freeze the chart for web alone
    // To set the chart width based on the sceen resolution
   
    // if (this.deviceWidth > 768) {
    //   const getoffset = this.globaloffset;
    //   $(window).off().scroll(function () {
        
    //     const scroll = $(window).scrollTop();
    //     if (scroll >= getoffset.top) {
    //       $('.chartScroll').addClass('chart-top');
    //       if($('.chartfixedForScroll').length != 0 && $('#chartfixed').css('top') == "0px")
    //       {
    //         $(".product-list").css("padding-top", $("#chartfixed").height())

    //       }else
    //       {
    //         $('.chartScroll').removeClass('chart-top');
    //         $(".product-list").css("padding-top", 0)
    //       }
    //     } else {
    //       $('.chartScroll').removeClass('chart-top');
    //       $(".product-list").css("padding-top", 0)
    //     }
    //   });
    // }
  }
  public triggerScrollTo(id, offsetHeight) {
    const config: ScrollToConfigOptions = {
      target: 'prductListObj' + id,
      duration: 0,
      easing: 'easeOutElastic',
    };
    if (offsetHeight !== null) {
      config['offset'] = offsetHeight;
    }
    this._scrollToService.scrollTo(config);
  }

  public triggerScrollTo2(offsetHeight) {
    const config: ScrollToConfigOptions = {
      target: offsetHeight,
      duration: 0,
      easing: 'easeOutElastic',
    };

    this._scrollToService.scrollTo(config);
  }

  // When dropdown open, outter click on "In active" place dropdown need to close
  @HostListener('window:mouseup', ['$event'])
  keyEvent(event: MouseEvent) {}
  ngOnInit() {
    //history.pushState(null, null, 'user-settings/63669df9a3226c1284e2070b');
    this.loadScript();

    this.residentialService.widthoutQuestionUserRequest = JSON.parse(sessionStorage.getItem('widthoutQuestionUserRequest'));

    const accountId = window.location.href.split('/').pop();
    history.pushState(null, '');
    var user = sessionStorage.getItem('userObj');
    if (!_.isEmpty(user)) {

      var json = JSON.parse(user)
      history.pushState(null, null, 'user-settings/'+ json._id);
      history.pushState(null, null, 'recommendation/compare-product/' +  json._id);
      
    }
    else
    {
      if(accountId == "90987")
      {
        
        history.pushState(null, null, 'pre-success?id=0');
        history.pushState(null, null, 'recommendation/compare-product/' + accountId);
        
        //history.pushState(null, null,'http://stage.honestgorilla.com');
        //history.pushState(null, null, 'recommendation/compare-product/' + accountId);
      }else
      {
        history.pushState(null, null, 'residentialQues');
        history.pushState(null, null, 'recommendation/compare-product/' + accountId);
      }



    }


   

    this.ProductTypeSelectList = sessionStorage.getItem('selectedProductType') ? this.setItemToArray(
      JSON.parse(sessionStorage.getItem('selectedProductType')) == null ? [] : JSON.parse(sessionStorage.getItem('selectedProductType')) 
    ): [];

    if(this.ProductTypeSelectList.length == 0)
    {
      this.ProductTypeSelectList.push("ShowAll")
      sessionStorage.setItem(
        'selectedProductType',
        JSON.stringify(this.ProductTypeSelectList)
      );

    }
  

    this.loadProductTypes.forEach((item, index, destArr) => {
      if (this.ProductTypeSelectList.filter(x => x == item.value ).length == 1) {
        item.checked = true;
        this.setProductTypes();
        this.prepaidwb4 = false;
        if(item.value != "ShowAll" )
        {
          this.prepaidwb4 = true;
        }
       
      }
    });

  

      sessionStorage.setItem(
      'userDetails',
      JSON.stringify(this.residentialService.user)
    );
    this.setSessionBasedPrerecommendation();
    this.setSelectedRecommendedProduct();
    this.setAllEnergyProvidersToCompare(true);
    this.setResidentialUsage();
    this.providersCount = this.providersCheckedListCount();
    const selectObj = document.getElementById('singleObj');
    this.residentialService.recommendations = this.recommendations;
    if(this.prepaidwb4 == true)
    {
      this.saveChanges(); 
    }

    var entered = true;
    this.location_.onPopState(() => {
      //history.back();
      // if(entered)
      // {
      //   setTimeout(function(){  
        //this.back_();
          // this.router.navigate([
          //   'user-settings',
          //  '63669df9a3226c1284e2070b',
          // ]);

      //   },100)
     
      //   entered = false;
      // }
     
  });

  $('html, body').animate(
    { scrollTop: 0 },
    200
  );


  if(this.recommendProduct == null || this.recommendProduct == undefined || this.recommendProduct.length == 0)
  {
    if(this.energyProviderList.length == 1)
    {
      const template: ElementRef<any> = this.noofferPopup;

      this.modalRef = this.modalService.show(
        template,
        Object.assign({}, { class: 'gray modal-small' }, this.ngbModalOptions)
        
      );
    }
      

  }

  if(this.recommendationObj != null  && this.recommendationObj != undefined && this.recommendationObj.current_usage != null && this.recommendationObj.current_usage != undefined)
  {
    sessionStorage.setItem(
      'DefaultUsage',
      JSON.stringify(this.recommendationObj.current_usage)
    );
  }
    
  generateTooltip();

  if (this.deviceWidth < 768 && this.residentialService.widthoutQuestionUserRequest != null) {


    // $(".Headermargin2").addClass("h-0");
    $(".Headermargin2").removeClass("Headermargin2");
    

   }
 
  }

  setResidentialUsage() {
    const usageObject = JSON.parse(sessionStorage.getItem('totalUsageValue'));

    var sqFtSize;
    if(this.questionsArrayData.length != 0)
    {
      sqFtSize = _.findWhere(this.questionsArrayData[0].userResponses, {
        res_question_id: '0011',
      });


      
    var usagevalue = sessionStorage.getItem('selectfilterusage');
    if(usagevalue == null)
    {
      if (sqFtSize.fieldValue < 1250) this.loadAvgUsages[0].checked = true;
      else if (
        Number(sqFtSize.fieldValue) >= 1250 &&
        Number(sqFtSize.fieldValue) <= 2250
      )
        this.loadAvgUsages[1].checked = true;
      else this.loadAvgUsages[2].checked = true;
    }
    else
    {
      
        if(usagevalue == '500')
          this.loadAvgUsages[0].checked = true;
        else if(usagevalue == '1000')
          this.loadAvgUsages[1].checked = true;
        else if(usagevalue == '2000')
          this.loadAvgUsages[2].checked = true;
        else
          this.loadAvgUsages[3].checked = true;

        if(this.loadAvgUsages[3].checked == true)
        {
          this.ShowUpdatedUsage = true;
        }

    }

    

    }
    else
    {
     


      var usagevalue = sessionStorage.getItem('selectfilterusage');
    if(usagevalue == null)
    {
      this.loadAvgUsages[1].checked = true;
    }
    else
    {
      
        if(usagevalue == '500')
          this.loadAvgUsages[0].checked = true;
        else if(usagevalue == '1000')
          this.loadAvgUsages[1].checked = true;
        else if(usagevalue == '2000')
          this.loadAvgUsages[2].checked = true;
        else
          this.loadAvgUsages[3].checked = true;

        if(this.loadAvgUsages[3].checked == true)
        {
          this.ShowUpdatedUsage = true;
        }

    }
    }
 

    

    // if (usageObject !== null && usageObject.modified)
    //   this.getResidentialUsage(sqFtSize, usageObject.totalUsage,this.getUtilityNameFromQuestionnaire(),dwelling_type);
  }

  getResidentialUsage(sqFtSize, usage,utility,dwellingtype) {
    this.loadAvgUsages[3].checked = true;
    this.loadAvgUsages[2].checked = false;
    this.loadAvgUsages[1].checked = false;
    this.loadAvgUsages[0].checked = false;
    const sqft_size_range =
      sqFtSize.fieldValue < 1250
        ? 'lt_1250'
        : Number(sqFtSize.fieldValue) >= 1250 &&
          Number(sqFtSize.fieldValue) <= 2250
        ? 'btw_1250_2250'
        : 'gt_2250';

    const body = new HttpParams().append(
      'sqFt', usage > 120000 ? sqft_size_range : usage
    ).append(
      'utilityName',utility

    ).append(
      'dwellingtype',dwellingtype

    )
    this.residentialService.getResidentialUsage(body).subscribe((res: any) => {
      this.monthlyUsageArr = res.usage_history;
      this.getRecommendationsPerModifiedAvgUsage(sqft_size_range);
      this.updategraph();
    });

 
  }

  setSelectedRecommendedProduct() {
    this.accountId = this.recommendationService.hg_accountId;
    if (!_.isEmpty(this.recommendationService.signupProduct)) {
      this.selectedProductValue = this.recommendationService.signupProduct;
      sessionStorage.setItem(
        'signupProduct',
        JSON.stringify(this.selectedProductValue)
      );
    } else {
      this.selectedProductValue = JSON.parse(
        sessionStorage.getItem('signupProduct')
      );
    }
  }

  setSessionBasedPrerecommendation() {
    if (sessionStorage.getItem('preRecommend'))
      this.residentialService.preRecommendation = JSON.parse(
        sessionStorage.getItem('preRecommend')
      );
  }

  fixChartSizePerResolution() {
    // Freeze the chart for web alone
    // To set the chart width based on the sceen resolution
    this.deviceWidth = window.innerWidth;


    if(this.deviceWidth < 1025)
    {
      this.hideFreezeopt = false;

    }else
    {
      this.hideFreezeopt = true;
      this.onfreeze();

    }

    if (this.deviceWidth > 768) {
      
    var getoffset = this.globaloffset;
    if(getoffset == undefined)
    {
      getoffset = $('#chartfixed').offset();
      this.globaloffset = $('#chartfixed').offset();
    }
    
      // $(window).off().scroll(function () {
       
      //   const scroll = $(window).scrollTop();
      //   if (scroll >= getoffset.top) {
      //     $('.chartScroll').addClass('chart-top');
      //       if($('.chartfixedForScroll').length != 0 && $('#chartfixed').css('top') == "0px")
      //       {
      //         $(".product-list").css("padding-top", $("#chartfixed").height())

      //       }else
      //       {
      //         $('.chartScroll').removeClass('chart-top');
      //         $(".product-list").css("padding-top", 0)
      //       }
      //   } else {
      //     $('.chartScroll').removeClass('chart-top');
      //      $(".product-list").css("padding-top", 0)
      //   }
      // });
    } else if (this.deviceWidth < 768) {
      const getoffset = $('.mobileTrigger').offset();
      $(window).scroll(function () {
        const scroll = $(window).scrollTop();
        if (scroll >= getoffset.top) {
          $('.chartScroll').addClass('chart-top');
        } else {
          $('.chartScroll').removeClass('chart-top');
        }
      });
    }
  }

  setAllEnergyProvidersToCompare(onload = false) {
    this.showheader = false;
    this.fixChartSizePerResolution();
    this.setAveragePriceKwh();
    const recommendObj = sessionStorage.getItem('recommendedProducts');
    this.checkQuestionFlowType(recommendObj);
    this.getRecommendedValuesPerSession();

    this.energyProviderList = this.setEnergyProviderWithKeyValuePair();
    this.energyProviderList.sort(this.dynamicSort('value'));
    this.assignEnergyProvidersList();
    this.productPriceList = this.getValueNewTierAveragePricePerKwh();
     try{
      
      this.inializeFn();
      this.loadHighChart();
      if(onload)
      {
        this.changeIUsageGraph(this.recommendProduct, 0,false);

      }else
      {
        this.changeIUsageGraph(this.recommendProduct, 0,true);
      }
      
     }catch{

     }

    if(onload)
    {
      if(this.residentialService.widthoutQuestionUserRequest != null)
      { 
      
      }else
      {
        this.openModal1();
      }
    }else
    {
      this.openModal1();
    }
  

    //this.openModal1();
    setTimeout(() => {
      this.onCloseHandled1();
      let activeIdx = 0;
    }, 1000);

    //  this.prepaidwb4 = true;
    //  this.renewableEnergyValue3 = true;
    //  this.assignEnergyProvidersList();
    if (sessionStorage.getItem('selectedFeatureData'))
      this.assignSelectedFeatures(
        sessionStorage.getItem('selectedFeatureData')
      );

    if (sessionStorage.getItem('selectedProductTypeData'))
      this.assignSelectedProductType(
        sessionStorage.getItem('selectedProductTypeData')
      );
  }

  getUtilityNameFromQuestionnaire() {
    if(this.questionsArrayData.length != 0)
    {
      const itemValue = _.findWhere(this.questionsArrayData[0].userResponses, {
        res_question_id: '008',
      });
      return itemValue.fieldValue.utility;

    }
    else
    {
      return this.residentialService.widthoutQuestionUserRequest["utilityName"];
    }

   
  }

  createDropDownValueObject() {
    this.dropDownValues =
      this.splitData[0] === 'Compare'
        ? this.setDropDownValuesForAll()
        : this.setDropDownValuesForSplitData();
  }

  setDropDownValuesForSplitData() {
    const drop = [];
    this.dropDownValues.map((row) => {
      this.splitData.includes(row)
        ? drop.push({ value: row, checked: true })
        : drop.push({ value: row, checked: false });
    });
    return drop;
  }

  setDropDownValuesForAll() {
    let drop = [];
    this.dropDownValues.map((row) => {
      if (row === '1000') drop.push({ value: row, checked: true });
      else drop.push({ value: row, checked: false });
    });
    return drop;
  }

  assignEnergyProvidersList() {
    const showAll = {
      checked: false,
      name: 'option1',
      product_key: '',
      value: 'Show All',
    };
    this.energyProviderList.push(showAll);
    this.energyProviderList = this.energyProviderList.map((value) => {
      return this.getEnergyCheckedListObj(value);
    });
    if (
      sessionStorage.getItem('selectedEnergyProvider') &&
      !sessionStorage.getItem('selectedEnergyProvider').includes('Show All')
    ) {
      this.checkedList = [];
      this.energyProviderList = this.energyProviderList.map((value) => {
        if (!this.checkEnergyProviderList(value.value)) {
          return {
            checked: false,
            value: value.value,
            name: 'option1',
            product_key: value.product_key,
          };
        } else {
          this.checkedList.push(value.value);
          return {
            checked: true,
            value: value.value,
            name: 'option1',
            product_key: value.product_key,
          };
        }
      });
    }
  }

  getEnergyCheckedListObj(value) {
    return {
      checked: value.value !== 'Show All' ? false : true,
      value: value.value,
      name: 'option1',
      product_key: value.product_key,
    };
  }

  getValueNewTierAveragePricePerKwh(): any {
    return this.recommendationObj.res_products_recommendations.map(function (
      value,
      key
    ) {
      return {
        color: '#ffffff',
        y: value.new_tier.ave_price_per_KWH * 100,
      };
    });
  }

  setEnergyProviderWithKeyValuePair(): any {
    const energyProvider =
      this.recommendationObj.res_products_recommendations.map(function (
        value,
        key
      ) {
        return {
          checked: true,
          value: value.energy_provider,
          name: 'option1',
          product_key: value.product_key,
        };
      });

    return _.uniq(energyProvider, function (item) {
      return item.value;
    });
  }

  getRecommendedValuesPerSession() {
    if (!_.isEmpty(sessionStorage.getItem('userResponse'))) {
      this.residentialResponses = JSON.parse(
        sessionStorage.getItem('userResponse')
      );
      this.questionsArrayData.push(this.residentialResponses);
      const TermValue = _.findWhere(this.questionsArrayData[0].userResponses, {
        res_question_id: '0026',
      });
      this.dropDownValue = TermValue.fieldValue;
      this.splitData = this.getTermsProviderDataPerSession();
      this.temporarySplit = this.splitData.includes('Compare')
        ? []
        : this.splitData;
      this.dropDownValues = _.uniq(
        this.recommendationObj.res_products_recommendations.map((a) =>
          a.terms.toString()
        )
      );
      this.dropDownValues = _.sortBy(this.dropDownValues, function (item) {
        return Number(item);
      });
      let dropvalues = '1000';
      this.dropDownValues.push(dropvalues);
      this.createDropDownValueObject();
      this.dropDownValues = _.sortBy(this.dropDownValues, function (item) {
        return Number(item);
      });
      this.splitData = this.getUniqueSplitData();
      this.checkedList = this.getEnergyProviderPerSession();
      if (this.deviceWidth < 768) this.dropDownValueSet();
      this.assignPreRecommendationValues();
      this.setEnergyProvidersRecordSet(this.currentPage);
      this.validateRecommendationsForSelectedData();
      // this.prerecommendation = this.recommendations;
      this.assignActiveClassToRecommendProduct();
      // this.getUniqueEnergyProviders();
    }
    else
    {
      
      this.dropDownValue = "Compare";
      this.splitData =  ["Compare"];
      this.temporarySplit = this.splitData.includes('Compare')
        ? []
        : this.splitData;
      this.dropDownValues = _.uniq(
        this.recommendationObj.res_products_recommendations.map((a) =>
          a.terms.toString()
        )
      );
      this.dropDownValues = _.sortBy(this.dropDownValues, function (item) {
        return Number(item);
      });
      let dropvalues = '1000';
      this.dropDownValues.push(dropvalues);
      this.createDropDownValueObject();
      this.dropDownValues = _.sortBy(this.dropDownValues, function (item) {
        return Number(item);
      });
      this.splitData = this.getUniqueSplitData();
      this.checkedList = this.getEnergyProviderPerSession();
      if (this.deviceWidth < 768) this.dropDownValueSet();
      this.assignPreRecommendationValues();
      this.setEnergyProvidersRecordSet(this.currentPage);
      this.validateRecommendationsForSelectedData();
      // this.prerecommendation = this.recommendations;
      this.assignActiveClassToRecommendProduct();
      // this.getUniqueEnergyProviders();
      
    }
  }

  getUniqueEnergyProviders(): any {
    if (this.splitData.length > 1) {
      this.prerecommendation = _.uniq(
        this.recommendations.map((value: any) => value)
      );
    }
  }
  getTermsProviderDataPerSession(): any[] {
    var values = this.setItemToArray(
      JSON.parse(sessionStorage.getItem('selectedProviderData'))
    );
    if(values.length != 0 && values.filter(x => x == "Compare").length == 1)
    {
      return ["Compare"];

    }else
    {
      return sessionStorage.getItem('selectedProviderData')
      ? this.setItemToArray(
          JSON.parse(sessionStorage.getItem('selectedProviderData'))
        )
      : this.setItemToArray(this.dropDownValue.split(' ')[0]);

    }

  }
  getEnergyProviderPerSession(): any[] {
    return sessionStorage.getItem('selectedEnergyProvider')
      ? JSON.parse(sessionStorage.getItem('selectedEnergyProvider'))
      : _.uniq(
          this.recommendationObj.res_products_recommendations.map(
            (itemValue: any) => itemValue.energy_provider
          )
        );
  }

  assignPreRecommendationValues(recall?) {
    this.recommendations = [];
    this.checkedList.map((list) => {
      this.splitData.map((row) => {
        this.recommendationObj.res_products_recommendations.map((recommend) => {
          if (
            recommend.terms.toString() === row &&
            recommend.energy_provider === list
          )
            this.recommendations.push(recommend);
        });
      });
    });
    this.recommendations = this.sortValuesPerAveragePricePerKwh(
      this.recommendations
    );

    this.prerecommendation = this.recommendations;

    if(this.recommendations.length == 0 && recall == null && this.onload == true)
    {
      this.splitData = _.uniq(
        this.recommendationObj.res_products_recommendations.map((a) =>
          a.terms.toString()
        )
      );

      this.splitData.push("1000");
      this.splitData.push("Compare");


      sessionStorage.setItem(
        'selectedProviderData',
        JSON.stringify(this.splitData)
      );
      this.dropDownValues[this.dropDownValues.length - 1].checked = true;

      this.assignPreRecommendationValues(true);
    }else
    {
      this.onload = false;
    }

  }

  energyProviderRecommendedProduct(recommendedProvider): any {
    if (recommendedProvider) {
      const uniqueValue = _.sortBy(recommendedProvider, function (item) {
        return Number((item.new_tier.ave_price_per_KWH * 100).toFixed(1));
      });
      return uniqueValue[0];
    }
  }

  sortValuesPerAveragePricePerKwh(item) {
    return _.sortBy(item, function (itemValue) {
      return Number((itemValue.new_tier.ave_price_per_KWH * 100).toFixed(1));
    });
  }

  getUniqueSplitData() {
    if (this.splitData[0] === 'Compare') {
      this.splitData = _.uniq(
        this.recommendationObj.res_products_recommendations.map((a) =>
          a.terms.toString()
        )
      );
    }
    return this.sortValues(this.splitData);
  }
  checkQuestionFlowType(recommendObj) {
    if (
      this.residentialService.questionFlowType !== 'add-address' &&
      !_.isEmpty(recommendObj)
    ) {
      this.recommendationObj = JSON.parse(recommendObj);
    } else {
      this.recommendationObj = this.recommendationService.recommendationObj;
    }
  }
  setAveragePriceKwh() {
    if (this.avg_price_kwh != undefined) {
      let splitdata = this.avg_price_kwh.split('.');
      this.avg_price_kwh = splitdata[1];
    }
  }
  getCancellationValues(ETF: string): string {
    const letters = /^[A-Za-z]+$/;
    return ETF.length > 0 && ETF.match(letters) ? ETF : `$${ETF}`;
  }

  assignActiveClassToRecommendProduct() {
    if (this.recommendations[0]) {
      this.recommendProduct = this.recommendations[0];
      const d = document.getElementById(this.recommendProduct.ProductID);
      if (d) d.classList.add('active');
    }
  }

  assignSelectedFeatures(itemValue) {
    this.renewableEnergyValue3 = false;
    if (itemValue === 'RenewableOnly') this.renewableEnergyValue1 = true;
    if (itemValue === 'NoDeposit') this.renewableEnergyValue2 = true;
    if (itemValue === 'showAll') {
      this.renewableEnergyValue1 = false;
      this.renewableEnergyValue2 = false;
      this.renewableEnergyValue3 = true;
    }
    this.doneclrrmoverenewable();
  }

  setFixedValueProductType() {
    let energshowall = <HTMLInputElement>document.getElementById('prepaidwb22');
    energshowall.checked = false;
    let energshowtalql = <HTMLInputElement>(
      document.getElementById('prepaidwb33')
    );
    energshowtalql.checked = false;

    let energshowal = <HTMLInputElement>document.getElementById('prepaidmb22');
    energshowal.checked = false;
    let energshowalql = <HTMLInputElement>(
      document.getElementById('prepaidmb33')
    );
    energshowalql.checked = false;
    let fixedFlag = <HTMLInputElement>document.getElementById('prepaidwb11');
    fixedFlag.checked = true;
    fixedFlag = <HTMLInputElement>document.getElementById('prepaidmb11');
    fixedFlag.checked = true;

    this.prepaidb22 = false;
    this.prepaidmb11 = true;

    this.prepaidwb1 = true;
    this.prepaidwb2 = false;
  }

  setVariableValueProductType() {
    let energshowall = <HTMLInputElement>document.getElementById('prepaidwb11');
    energshowall.checked = false;
    let energshowalql = <HTMLInputElement>(
      document.getElementById('prepaidwb33')
    );
    energshowalql.checked = false;

    let energwall = <HTMLInputElement>document.getElementById('prepaidmb11');
    energwall.checked = false;
    let enehowalql = <HTMLInputElement>document.getElementById('prepaidmb33');
    enehowalql.checked = false;

    let variableFlag = <HTMLInputElement>document.getElementById('prepaidmb22');
    variableFlag.checked = true;
    variableFlag = <HTMLInputElement>document.getElementById('prepaidwb22');
    variableFlag.checked = true;

    this.prepaidmb11 = false;
    this.prepaidb22 = true;

    this.prepaidwb1 = false;
    this.prepaidwb2 = true;
  }

  setShowValueProductType() {
    let energshowall = <HTMLInputElement>document.getElementById('prepaidwb11');
    energshowall.checked = false;
    let energshowal2l = <HTMLInputElement>(
      document.getElementById('prepaidwb22')
    );
    energshowal2l.checked = false;

    let rgshowall = <HTMLInputElement>document.getElementById('prepaidmb11');
    rgshowall.checked = false;
    let enerowal2l = <HTMLInputElement>document.getElementById('prepaidmb22');
    enerowal2l.checked = false;

    this.prepaidb22 = false;
    this.prepaidmb11 = false;

    this.prepaidwb1 = false;
    this.prepaidwb2 = false;
    this.noproduct = false;
  }

  assignSelectedProductType(itemValue) {
    this.loadProductActionValues[itemValue]();
    this.doneclrrmoveProduct();
  }
  checkEnergyProviderList(itemValue) {
    const selectedEnergyProvider = JSON.parse(
      sessionStorage.getItem('selectedEnergyProvider')
    );
    return selectedEnergyProvider.find((a) => a === itemValue);
  }
  setItemToArray(item) {
    return Array.isArray(item) ? item : [item];
  }

  sortValues(itemValue) {
    return _.sortBy(itemValue, function (item) {
      return Number(item);
    });
  }

  dropDownValueSet() {
    let termValue, elemt;
    if (this.splitData.length === this.dropDownValues.length) {
      termValue = _.findWhere(this.questionsArrayData[0].userResponses, {
        res_question_id: '0026',
      });
      if (this.deviceWidth < 768) {
        elemt = <HTMLInputElement>(
          document.getElementById('contractTerm' + this.dropDownValues.length)
        );
        elemt.checked = true;
      } else {
        elemt = <HTMLInputElement>(
          document.getElementById('contractTermwb' + this.dropDownValues.length)
        );
        elemt.checked = true;
      }
    } else {
      if (
        sessionStorage.getItem('selectedProviderData') &&
        !sessionStorage.getItem('selectedProviderData').includes('Compare')
      ) {
        this.checkTermDataSelected();
      } else {
        if (this.questionsArrayData.length != 0) {
        
          termValue = _.findWhere(this.questionsArrayData[0].userResponses, {
            res_question_id: '0026',
          });
          if (termValue.fieldValue !== 'Compare All') {
            this.checkTermDataSelected();
          }
          if (termValue.fieldValue === 'Compare All') {
            this.checkTermForCompareAll();
          }
        }else
        {
          this.checkTermForCompareAll();
        }
       
      }
    }
  }

  checkTermForCompareAll() {
    let elemt;
    const termValue = '1000';
    this.dropDownValues.map((row, i) => {
      if (row === termValue) {
        elemt =
          this.deviceWidth > 768
            ? <HTMLInputElement>(
                document.getElementById('contractTermwb' + (i + 1))
              )
            : <HTMLInputElement>(
                document.getElementById('contractTerm' + (i + 1))
              );
        elemt.checked = true;
      }
    });
  }

  checkTermDataSelected() {
    let elemt;
    this.dropDownValues.map((row, i) => {
      const index = this.splitData.findIndex((a) => a === row);
      if (index >= 0) {
        elemt =
          this.deviceWidth > 768
            ? <HTMLInputElement>(
                document.getElementById('contractTermwb' + (i + 1))
              )
            : <HTMLInputElement>(
                document.getElementById('contractTerm' + (i + 1))
              );
        elemt.checked = true;
      }
    });
  }

  // Mobile view drop down click - Right
  rightarrowclick() {
    if (this.state === this.maxState) {
      this.state = 0;
    } else {
      this.state++;
      this.leftyarrow = true;
      this.rightyArrow = false;
      const valueForShadow = document.getElementById('shadowProcess');
      valueForShadow.classList.remove('shadow-after');
      valueForShadow.classList.add('shadow-before');
    }
    $('.container_element').animate(
      { scrollLeft: (this.winWidth - 100) * this.state + 'px' },
      800
    );
  }
  ngAfterViewInit(): void {
      
    window.dispatchEvent(new Event('resize'));
    this.maxAveragePriceObj = _.max(
      this.recommendationObj.res_products_recommendations,
      function (stooge) {
        return stooge.new_tier.ave_price_per_KWH;
      }
    );
    this.maxMonthlyBillObj = _.max(
      this.recommendationObj.res_products_recommendations,
      function (stooge) {
        return stooge.new_tier.ave_monthly_bill;
      }
    );
    this.maxAveragePrice = (
      Number(this.maxAveragePriceObj.new_tier.ave_price_per_KWH) * 100
    ).toFixed(1);
    this.maxMonthlyBill =
      this.maxMonthlyBillObj.new_tier.ave_monthly_bill.toFixed(1);
    const avgElements = document.getElementsByClassName('avgvalue');
    for (let i = 0; i < avgElements.length; i++) {
      if (avgElements[i].classList.contains('avgvalue')) {
        if (
          this.maxAveragePrice.length >= 11 ||
          this.maxMonthlyBill.length >= 11
        ) {
          avgElements[i].classList.add('avgpricelen32');
        } else if (
          this.maxAveragePrice.length === 10 ||
          this.maxMonthlyBill.length === 10
        ) {
          avgElements[i].classList.add('avgpricelen37');
        } else if (
          this.maxAveragePrice.length === 9 ||
          this.maxMonthlyBill.length === 9
        ) {
          avgElements[i].classList.add('avgpricelen42');
        } else if (
          this.maxAveragePrice.length === 8 ||
          this.maxMonthlyBill.length === 8
        ) {
          avgElements[i].classList.add('avgpricelen46');
        } else if (
          this.maxAveragePrice.length === 7 ||
          this.maxMonthlyBill.length === 7
        ) {
          avgElements[i].classList.add('avgpricelen50');
        } else if (
          this.maxAveragePrice.length <= 6 ||
          this.maxMonthlyBill.length <= 6
        ) {
          avgElements[i].classList.add('mobavgpricelen32');
        }
      }
    }
    // To set the chart width based on the sceen resolution
    this.deviceWidth = window.innerWidth;
    if (this.deviceWidth < 768) {
      this.Ismobileview = true;
      const getoffset = $('.mobileTrigger').offset();
      const getfheight = $('.chartfixed').outerHeight();
      // $('.chartfixed').parent().css('min-height', getfheight);

      $(window).scroll(function () {
        const scroll = $(window).scrollTop();
        if (scroll >= getoffset.top) {
          $('.chartScroll').addClass('chart-top');
          $('.chart-top .chartfixedForScroll').css('top', '-267px');
        } else {
          $('.chartScroll').removeClass('chart-top');
        }
      });
    }

    
  }

  ngAfterViewChecked(): void {
     
   
    //Called after every check of the component's view. Applies to components only.
    //Add 'implements AfterViewChecked' to the class.
    if (this.selectTerm) {
      this.dropDownValueSet();
      this.selectTerm = false;
    }
    if (!_.isEmpty(this.lastUncheck)) {
      if (this.lastUncheck != '1000') {
        this.temporarySplit[0] = this.lastUncheck;
      }

      this.splitData = this.temporarySplit;
      this.dropDownValueSet();
      this.lastUncheck = '';
    }

    if (!_.isEmpty(this.lastUncheckProvider)) {
      this.checkedList[0] = this.lastUncheckProvider;
      const checkedProvider = this.lastUncheckProvider;
      _.each(this.energyProviderList, function (item) {
        if (item.value === checkedProvider) {
          return (item.checked = true);
        }
      });
      this.lastUncheckProvider = '';
    }

    this.deviceWidth = window.innerWidth;
    if (this.deviceWidth < 768) {
      this.Ismobileview = true;
    }else
    {
      this.Ismobileview = false;
    }

  // this.deviceWidth = window.innerWidth;
  // if(this.deviceWidth < 1025)
  // {
  //   this.hideFreezeopt = false;
  //   $(".product-list").css("padding-top", 0)
  // }else
  // {
  //   this.hideFreezeopt = true;
  //   if($('.chartfixedForScroll').length != 0 && $('#chartfixed').css('top') == "0px")
  //   {
  //     $(".product-list").css("padding-top", $("#chartfixed").height())

  //   }else
  //   {
  //     $(".product-list").css("padding-top", 0)
  //   }
  // }


  }

  // Mobile view drop down click - Left
  leftarrowclick() {
    if (this.state === 0) {
      this.state = this.maxState;
    } else {
      this.state--;
      this.leftyarrow = false;
      this.rightyArrow = true;
      const valueForShadowleft = document.getElementById('shadowProcess');
      valueForShadowleft.classList.remove('shadow-before');
      valueForShadowleft.classList.add('shadow-after');
    }
    $('.container_element').animate(
      { scrollLeft: (this.winWidth - 100) * this.state + 'px' },
      800
    );
  }

  // Init method
  inializeFn() {
    // for average amount change below gaph
    this.graphSelectedProduct =
      this.productIndex >= 0
        ? this.recommendations[this.productIndex]
        : this.recommendProduct;
    this.avgMthlyUsage = Math.round(
      this.recommendProduct.new_tier.ave_monthly_usage
    );
    // For graph reset value and initial value -> while opening the edit
    if (!this.avgValueChanged)
      this.monthlyUsageArr = this.recommendationObj.current_usage;
    if (this.avg_price_kwh != undefined) {
      let splitdata = this.avg_price_kwh.split('.');
      this.avg_price_kwh = splitdata[1];
    }
    // set that value in local storage to reset
    sessionStorage.setItem(
      'monthlyUsage_recommendation',
      JSON.stringify(this.recommendationObj)
    );

    // To get the old value
    this.oldValue = this.recommendationObj.current_usage.map(function (
      value,
      key
    ) {
      return {
        point: value.month,
        color: 'rgba(206,206,206,0.5)',
        avg_energy_charge_per_KWH: value.avg_energy_charge_per_KWH,
        y: Number(value.avg_energy_charge_per_KWH) * Number(value.usage),
        usage: Number(value.usage),
      };
    });

    // To change the color if the edit option is enabled
    let color = '#ffc214';
    if (this.showOption) {
      color = 'rgba(255, 194, 20,0.5)';
    }
    // recommended values
    if (this.updateProductChart === false) {
      
      this.newValue = this.recommendationObj.res_products_recommendations[
        this.productIndex
      ].monthly_usage.map(function (value, key) {
        return {
          point: value.month,
          color: color,
          avg_energy_charge_per_KWH: value.avg_energy_charge_per_KWH,
          y: value.avg_energy_charge_per_KWH,
          energy_charge_per_month: value.total_energy_charge_per_month
            ? value.total_energy_charge_per_month
            : 0,
          usage: value.usage,
        };
      });
      for (let i = 0; i < this.oldValue.length; i++) {
        for (let j = 0; j < this.newValue.length; j++) {
          if (this.oldValue[i].point === this.newValue[j].point) {
            this.newValue[j].y = Math.round(
              Number(this.newValue[j].y) * Number(this.oldValue[i].usage)
            );
            // To change the selected bar color if it is in edit mode
            if (this.showOption && this.selectedIndex === j) {
              this.newValue[j].color = '#ffc214';
            }
          }
        }
      }
    } else {
      for (let i = 0; i < this.oldValue.length; i++) {
        for (let j = 0; j < this.newValue.length; j++) {
          if (this.oldValue[i].point === this.newValue[j].point) {
            this.newValue[j].y = Math.round(
              Number(this.newValue[j].energy_charge_per_month)
            );
            // To change the selected bar color if it is in edit mode
            if (this.showOption && this.selectedIndex === j) {
              this.newValue[j].color = '#ffc214';
            }
          }
        }
      }
    }
    this.loadHighChart();
  }

  // To load the highchart
  loadHighChart() {
    
    const self = this;
    // Left side highchart
    this.highChartsOptions = {
      chart: {
        renderTo: 'container',
        type: 'column',
        marginTop: 60,
      },
      xAxis: {
        gridLineWidth: 1,
        gridLineColor: '#e2e2e2',
        categories: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ],
        labels: {
          formatter: function (event) {
            // To show the total_energy_charge_per_month below month label in x-axis
            const series2Val = !_.isEmpty(self.visibleGraph)
              ? self.visibleGraph
              : self.highChartsOptions.series[1]
              ? self.highChartsOptions.series[1]
              : self.highChartsOptions.series[0];
            return (
              event.value +
              '<br>' +
              '$' +
              (!_.isEmpty(series2Val)
                ? Math.round(series2Val.data[event.pos].energy_charge_per_month)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
                  '<br>' +
                  (self.highChartsOptions.series[1] != undefined
                    ? (
                        self.highChartsOptions.series[1].data[event.pos]
                          .avg_energy_charge_per_KWH * 100
                      ).toFixed(1) + '¢'
                    : (
                        self.highChartsOptions.series[0].data[event.pos]
                          .avg_energy_charge_per_KWH * 100
                      ).toFixed(1) + '¢')
                : Math.round(
                    self.highChartsOptions.series[0].data[event.pos]
                      .energy_charge_per_month
                  )
              )
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            );
          },
          autoRotation: false,
          style: {
            'font-family': 'Calibre',
            'font-size': '13px',
          },
        },
      },
      // yAxis: [{
      //   title: true,
      //   labels: {
      //     overflow: 'justify',
      //     enabled: true,
      //   },
      //   gridLineWidth: 0,
        
      // },
      // // { // Secondary Y-axis
      // //       opposite: true, // This makes the axis appear on the opposite side
      // //       title: {
      // //           text: 'Secondary Data'
      // //       },
      // //       lineWidth: 1
      // //   }
      // ],
       yAxis: [{ // Primary yAxis
        //title: true,
        gridLineWidth: 1,
        gridLineColor: '#e2e2e2',
        labels: {
            format: '{value}¢',
           style: {
            'font-family': 'Calibre',
            'font-size': '13px',
            'color':'#ED1976'
          },
            enabled: true,
        }, 
        title: {
            text: 'Avg Price in cents',
            style: {
            'font-family': 'Calibre',
            'font-size': '13px',
            'color':'#ED1976'
          },
        }
    }, { // Secondary yAxis
        //title: false,
        gridLineWidth: 0,
        title: {
            text: 'Total Price in $',
            style: {
            'font-family': 'Calibre',
            'font-size': '13px',
            'color':'#ffc214'
          },
        },
        labels: {
            format: '${value}',
            style: {
            'font-family': 'Calibre',
            'font-size': '13px',
            'color':'#ffc214'
          },
            enabled: true,
        },
        opposite: true
    }],
      plotOptions: {
        series: {
          // colorByPoint: true,
          cursor: 'pointer',
          point: {
            events: {
              click: function (event) {
                self.clicks++; // count clicks
                if (self.clicks === 1) {
                  self.timer = setTimeout(function () {
                    self.clicks = 0; // after action performed, reset counter
                    if (
                      self.selectedIndex !== event.point.index &&
                      event.point.color === 'rgba(255, 194, 20,0.5)'
                    ) {
                      self.updateChart(event);
                    } else {
                      self.clicks = 0; // after action performed, reset counter
                    }
                  }, self.DELAY);
                } else {
                  clearTimeout(self.timer); // prevent single-click action
                  // To reset the color for already selected bar
                  if (!_.isEmpty(self.highChartsOptions.series[1])) {
                    self.highChartsOptions.series[1].data[
                      self.selectedIndex
                    ].color = 'rgba(255, 194, 20,0.5)';
                  } else {
                    self.highChartsOptions.series[0].data[
                      self.selectedIndex
                    ].color = 'rgba(255, 194, 20,0.5)';
                  }
                  // Changing the current Index as selected index
                  self.selectedIndex = event.point.index;
                  self.monthName = event.point.point;

                  // Calculating the updatedNewValue if the monthly usage is changed
                  self.updatedNewValue =
                    self.oldValue[self.selectedIndex].usage;

                  // To check the value is changed or not
                  document.getElementById('editValue')['value'] =
                    self.updatedNewValue;
                  const elem =
                    document.getElementsByClassName('highcharts-tooltip');
                  const tooltipElem =
                    document.getElementsByClassName('updatept');
                  tooltipElem[0]['style'].top = elem[1]['style'].top;
                  tooltipElem[0]['style'].left = elem[1]['style'].left;

                  if (!_.isEmpty(self.highChartsOptions.series[1])) {
                    self.highChartsOptions.series[1].data[
                      self.selectedIndex
                    ].color = '#ffc214';
                  } else {
                    self.highChartsOptions.series[0].data[
                      self.selectedIndex
                    ].color = '#ffc214';
                  }
                  self.updateValue = true;
                  self.clicks = 0; // after action performed, reset counter
                }
              },
            },
          },
          pointWidth: self.pointWidth,
          events: {
            legendItemClick: function (e) {
              const visibility = this.visible ? 'visible' : 'hidden';
              if (_.isEmpty(self.highChartsOptions.series[1])) {
                // new service -> so restrict the click action
                e.preventDefault();
              } else {
                const chart = this.chart;
                const index = this.index;
                let atleastOneVisible = false;
                // assign the visible graph to change the x-axis label on legend click
                $.each(chart.series, function (i, serie) {
                  if (serie.visible && serie.index !== index) {
                    atleastOneVisible = true;
                    self.visibleGraph =
                      self.highChartsOptions.series[serie.index];
                  }
                });
                // if both are visible then choose the new value

                if (
                  atleastOneVisible &&
                  ((chart.series[0].visible === false &&
                    chart.series[1].visible === true) ||
                    (chart.series[1].visible === false &&
                      chart.series[0].visible === true))
                ) {
                  self.visibleGraph = self.highChartsOptions.series[1];
                } else {
                  // before this code is not written here . --siva j
                  self.visibleGraph = self.highChartsOptions.series[0];
                }
                // to show atleast one legend
                if (!atleastOneVisible) {
                  e.preventDefault();
                } else {
                  self.updateValue = true;
                }
              }
            },
          },
        },
        column: {
          pointWidth: 20,
          groupPadding: 0.5,
        },
      },
      tooltip: {
        style: {
          pointerEvents: 'all',
        },
        useHTML: true,
        formatter: function (event) {
          // To show the tooltip with current usage value
          let tooltipHTML = this.x;
          const series2Val = self.highChartsOptions.series[1];
          // if (!_.isEmpty(series2Val)) {
          //   tooltipHTML =
          //     '<div class="chart_tool_tip">' +
          //     this.x +
          //     '<span class="d-block">' +
          //     Math.round(
          //       self.highChartsOptions.series[0].data[this.point.index].usage
          //     )
          //       .toString()
          //       .replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
          //     '</span>' +
          //     '</div>';
          //   return tooltipHTML;
          // } else {
          //console.log(self.oldValue[this.point.index])
          //console.log(self.highChartsOptions.series[0].data[this.point.index])
          
            tooltipHTML =
              '<div class="chart_tool_tip">' +
              '<span class="d-block">' +
              this.x + ' ' + 
              Math.round(self.oldValue[this.point.index].usage)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',') + " kWh at "+  Number((self.highChartsOptions.series[0].data[this.point.index].avg_energy_charge_per_KWH * 100 ).toFixed(1)) +"¢"
              '</span>' +
              '</div>';
            return tooltipHTML;
        //  }
        },
      },
      title: {
        text: null,
      },
      credits: {
        enabled: false,
      },
      legend: {
        layout: 'vertical',
        align: 'left',
        verticalAlign: 'top',
        floating: true,
        x: 0,
        y: 0,
        backgroundColor: '#FFFFFF',
        shadow: false,
        useHTML: true,
        margin: 100,
        itemDistance: 50,
        itemMarginTop: -20,
        itemMarginBottom: 20,
        itemStyle: {
          color: '#000000',
          fontWeight: 'normal',
          fontSize: '14px',
          fontFamily: 'Calibre',
        },
        symbolRadius: 0,
        labelFormatter: function (event) {
          return this.name;
        },
      },
      lang: { thousandsSep: ',' },
      series: [
        {
          name: this.graaphLabelName
            ? this.graaphLabelName
            : 'New 12 Months Rate',
          data: this.newValue,
          color: '#ffc214',
        },
      ],
    };

    var reats = this.newValue;
    var newRates = this.getAvgRates(reats);
    // To check 'New Service' and 'Switching providers'
    if (this.recommendationObj.service_type !== 'Switching Providers') {
      this.highChartsOptions.series = [
         {

          name: this.graaphLabelName
            ? this.graaphLabelName + " Total Price"
            : 'New 12 Months Rate',
          data: this.newValue,
          color: '#ffc214',
          yAxis: 1
        },
        {
          type: 'line',
          name: this.graaphLabelName
            ? this.graaphLabelName + " Average Price"
            : 'New 12 Months Rate',
          data: newRates,
          color: '#ED1976',
        },
       
      ];
      // to disable the legend hover
      this.highChartsOptions.legend.itemStyle = {
        color: '#000000',
        fontWeight: 'normal',
        fontSize: '14px',
        fontFamily: 'Calibre',
        cursor: 'default',
      };
      this.updateValue = true;
    }
    if (window.screen.availWidth < 595) {
      this.highChartsOptions.plotOptions.series.pointWidth = 22;
    } else {
      this.highChartsOptions.plotOptions.series.pointWidth = 35;
    }
  }

  // To get the min value for y-axis
  getMinValue() {
    
    let minVal;
    if (!_.isEmpty(this.highChartsOptions.series[1])) {
      minVal = _.min(this.highChartsOptions.series[1].data, function (object) {
        return object.y;
      });
    } else {
      minVal = _.min(this.highChartsOptions.series[0].data, function (object) {
        return object.y;
      });
    }
    const oldObj = _.findKey(this.oldValue, function (obj) {
      return obj.point === minVal.point;
    });
    return (
      Number(minVal.avg_energy_charge_per_KWH) *
      Number(this.oldValue[oldObj].usage)
    );
  }

  back() {
    this.router.navigate([
      'recommendation/single-product',
      this.recommendationService.hg_accountId,
    ]);


    
  }
  seeDetailDes(id, i) {
    this.showDetal = true;
    this.showAll = true;
    this.seeDetailShow = false;
    this.selectedTerm = id;

    // adding the border for selected product - mobile view
    this.addSeeDetailsBorder = true;
    this.hideAlll = true;
  }

  orderNownav() {
    this.router.navigate([
      'energyplan-confirmation',
      this.recommendationService.hg_accountId,
    ]);
  }

  // Close function (down- arrow)
  showDetail() {
    if (this.showDetal === true) {
      this.showDetal = false;
      this.showAll = false;
      this.hideAlll = false;
    } else {
      this.showDetal = true;
      this.showAll = true;
      this.hideAlll = true;
    }
  }

  // Close function (down- arrow)
  showDetail1() {
    this.showDetal = false;
    this.showAll = false;
    this.hideAlll = false;
  }

  // Update the barchart
  changeBarChart(selectedProduct) {
    const annuvalsavingupdatechart = document.getElementById('annualsaving');
    const billamountupdatechart = document.getElementById('billamount');
    const editupdatechart = document.getElementById('chartbottom');
    this.showUndo = false;
    this.showUpdate = false;
    const usage = sessionStorage.getItem('monthlyUsage_recommendation');
    if (!_.isEmpty(usage) && !this.avgValueChanged) {
      this.monthlyUsageArr = JSON.parse(usage).current_usage;
    }
    if (
      annuvalsavingupdatechart !== null &&
      annuvalsavingupdatechart.classList.contains('avgvalue') &&
      billamountupdatechart.classList.contains('avgvalue')
    ) {
      annuvalsavingupdatechart.classList.remove('avgvalue');
      billamountupdatechart.classList.remove('avgvalue');
    } else if (
      billamountupdatechart !== null &&
      billamountupdatechart.classList.contains('avgvalue')
    ) {
      billamountupdatechart.classList.remove('avgvalue');
    } else {
      if (annuvalsavingupdatechart !== null) {
        annuvalsavingupdatechart.classList.remove('avgvaluemobil');
        billamountupdatechart.classList.remove('avgvaluemobil');
      } else {
        billamountupdatechart.classList.remove('avgvaluemobil');
      }
    }
    editupdatechart.classList.remove('chartbottomvalue');
    this.editoption = true;
    
    const newValue = selectedProduct.monthly_usage.map((value, index) => {
      return {
        point: value.month,
        color: '#ffc214',
        avg_energy_charge_per_KWH: value.avg_energy_charge_per_KWH,
        y: value.avg_energy_charge_per_KWH,
        energy_charge_per_month: value.total_energy_charge_per_month,
        usage: this.monthlyUsageArr[index].usage,
      };
    });

    // To calculate the  y value as => usage * price/kWh
    for (let i = 0; i < this.oldValue.length; i++) {
      for (let j = 0; j < newValue.length; j++) {
        if (this.oldValue[i].point === newValue[j].point) {
          newValue[j].y = Math.round(
            Number(newValue[j].y) * Number(this.oldValue[i].usage)
          );
        }
      }
    }
    
    if (!_.isEmpty(this.highChartsOptions.series[1])) {
      this.highChartsOptions.series[1].data = newValue;
    } else {
      this.highChartsOptions.series[0].data = newValue;
    }
    this.newValue = newValue;
    this.updateValue = true;
    this.loadHighChart();
  }

  // To show the options to edit the chart values
  editChart(event) {
    let color = '#ffc214';
    if (this.showOption) {
      this.showOption = false;
      this.editoption = true;
    } else {
      this.showOption = true;
      color = 'rgba(255, 194, 20,0.5)';
      this.editoption = false;
    }
    
    // Changing the chart to disable
    this.newValue = this.recommendationObj.res_products_recommendations[
      this.productIndex
    ].monthly_usage.map(function (value, key) {
      return {
        point: value.month,
        color: color,
        avg_energy_charge_per_KWH: value.avg_energy_charge_per_KWH,
        y: value.avg_energy_charge_per_KWH,
        energy_charge_per_month: value.total_energy_charge_per_month,
      };
    });

    // To calculate the  y value as => usage * price/kWh
    for (let i = 0; i < this.oldValue.length; i++) {
      for (let j = 0; j < this.newValue.length; j++) {
        if (this.oldValue[i].point === this.newValue[j].point) {
          this.newValue[j].y = Math.round(
            Number(this.newValue[j].y) * Number(this.oldValue[i].usage)
          );
        }
      }
    }
    // To update the highchart value
    if (!_.isEmpty(this.highChartsOptions.series[1])) {
      this.highChartsOptions.series[1].data = this.newValue;
    } else {
      this.highChartsOptions.series[0].data = this.newValue;
    }
    this.monthName = this.newValue[0].point;
    this.updatedNewValue = this.oldValue[0].usage;
    this.selectedIndex = 0;
    this.updateChart(event);
  }

  // Update edit graph
  updategraph(isupdateFromButton?) {
    debugger
    //this.ShowUpdatedUsage = false;
    let totalUsage = 0;
    for (let i = 0; i < this.monthlyUsageArr.length; i++) {
      if (
        this.recommendationObj.current_usage[i].month ===
        this.monthlyUsageArr[i].month
      ) {
        this.recommendationObj.current_usage[i].usage = Number(
          this.monthlyUsageArr[i].usage
        );
      }
      totalUsage += this.monthlyUsageArr[i].usage;
    }

    this.clicks = 0; // after action performed, reset counter
    const res_usage = {
      usage_history: this.recommendationObj.current_usage,
      service_type: this.recommendationObj.service_type,
      hg_accountId: this.recommendationObj.hg_accountId,
      avg_price_kwh:
        this.recommendationObj.current_usage[0].avg_energy_charge_per_KWH,
      res_products_recommendations:
        this.recommendationObj.res_products_recommendations,
    };

    const body = new HttpParams().append(
      'userResponses',
      JSON.stringify(res_usage)
    );

    this.http
      .post(this.url + '/updateRecommendation', body)
      .subscribe((res: any) => {
        this.updateRecommendationValues(res);
        this.showOption = false;
        this.editoption = true;
        this.inializeFn();
        this.onCloseHandled();
        this.loadAvgUsages[3].checked = false;
        this.loadAvgUsages[2].checked = false;
        this.loadAvgUsages[1].checked = false;
        this.loadAvgUsages[0].checked = false;
        if(isupdateFromButton)
        {
          sessionStorage.setItem(
            'selectfilterusage',
            'Custom'
          );

          this.ShowUpdatedUsage = true;
        }else
        {

          
          var usagevalue = sessionStorage.getItem('selectfilterusage');
          if(usagevalue == 'Custom')
          {
            this.ShowUpdatedUsage = true
          }
          else
          {
            this.ShowUpdatedUsage = false

          }
    
        }


        
    var usagevalue = sessionStorage.getItem('selectfilterusage');
    if(usagevalue == null)
    {
      this.loadAvgUsages[0].checked = true;
    }
    else
    {
        if(usagevalue == '500')
          this.loadAvgUsages[0].checked = true;
        else if(usagevalue == '1000')
          this.loadAvgUsages[1].checked = true;
        else if(usagevalue == '2000')
          this.loadAvgUsages[2].checked = true;
        else
          this.loadAvgUsages[3].checked = true;

    }

       
      });
  }

  private updateRecommendationValues(res: Response) {
    const result = res;
    this.recommendationObj = result;
    sessionStorage.setItem(
      'recommendedProducts',
      JSON.stringify(this.recommendationObj)
    );
    this.recommendationService.recommendationObj = this.recommendationObj;
     this.applyRecommendationFilters();
  }

  setMonthlyUsageRecommendationObj() {
    if (this.avg_price_kwh != undefined) {
      this.recommendationObj.current_usage[0].avg_energy_charge_per_KWH =
        '0.' + this.avg_price_kwh;
      this.recommendationObj.current_usage[1].avg_energy_charge_per_KWH =
        '0.' + this.avg_price_kwh;
      this.recommendationObj.current_usage[2].avg_energy_charge_per_KWH =
        '0.' + this.avg_price_kwh;
      this.recommendationObj.current_usage[3].avg_energy_charge_per_KWH =
        '0.' + this.avg_price_kwh;
      this.recommendationObj.current_usage[4].avg_energy_charge_per_KWH =
        '0.' + this.avg_price_kwh;
      this.recommendationObj.current_usage[5].avg_energy_charge_per_KWH =
        '0.' + this.avg_price_kwh;
      this.recommendationObj.current_usage[6].avg_energy_charge_per_KWH =
        '0.' + this.avg_price_kwh;
      this.recommendationObj.current_usage[7].avg_energy_charge_per_KWH =
        '0.' + this.avg_price_kwh;
      this.recommendationObj.current_usage[8].avg_energy_charge_per_KWH =
        '0.' + this.avg_price_kwh;
      this.recommendationObj.current_usage[9].avg_energy_charge_per_KWH =
        '0.' + this.avg_price_kwh;
      this.recommendationObj.current_usage[10].avg_energy_charge_per_KWH =
        '0.' + this.avg_price_kwh;
      this.recommendationObj.current_usage[11].avg_energy_charge_per_KWH =
        '0.' + this.avg_price_kwh;
    }
    this.recommendationObj.current_usage[0].avg_price_kwh =
      this.recommendationObj.current_usage[0].avg_energy_charge_per_KWH;
    this.monthlyUsageArr[0].avg_price_kwh =
      this.recommendationObj.current_usage[0].avg_energy_charge_per_KWH;
    this.recommendationObj.res_products_recommendations[0].monthly_usage[0].avg_energy_charge_per_KWH =
      this.monthlyUsageArr[0].avg_energy_charge_per_KWH;
    this.recommendationObj.res_products_recommendations[0].monthly_usage[1].avg_energy_charge_per_KWH =
      this.monthlyUsageArr[0].avg_energy_charge_per_KWH;
    this.recommendationObj.res_products_recommendations[0].monthly_usage[2].avg_energy_charge_per_KWH =
      this.monthlyUsageArr[0].avg_energy_charge_per_KWH;
    this.recommendationObj.res_products_recommendations[0].monthly_usage[3].avg_energy_charge_per_KWH =
      this.monthlyUsageArr[0].avg_energy_charge_per_KWH;
    this.recommendationObj.res_products_recommendations[0].monthly_usage[4].avg_energy_charge_per_KWH =
      this.monthlyUsageArr[0].avg_energy_charge_per_KWH;
    this.recommendationObj.res_products_recommendations[0].monthly_usage[5].avg_energy_charge_per_KWH =
      this.monthlyUsageArr[0].avg_energy_charge_per_KWH;
    this.recommendationObj.res_products_recommendations[0].monthly_usage[6].avg_energy_charge_per_KWH =
      this.monthlyUsageArr[0].avg_energy_charge_per_KWH;
    this.recommendationObj.res_products_recommendations[0].monthly_usage[7].avg_energy_charge_per_KWH =
      this.monthlyUsageArr[0].avg_energy_charge_per_KWH;
    this.recommendationObj.res_products_recommendations[0].monthly_usage[8].avg_energy_charge_per_KWH =
      this.monthlyUsageArr[0].avg_energy_charge_per_KWH;
    this.recommendationObj.res_products_recommendations[0].monthly_usage[9].avg_energy_charge_per_KWH =
      this.monthlyUsageArr[0].avg_energy_charge_per_KWH;
    this.recommendationObj.res_products_recommendations[0].monthly_usage[10].avg_energy_charge_per_KWH =
      this.monthlyUsageArr[0].avg_energy_charge_per_KWH;
    this.recommendationObj.res_products_recommendations[0].monthly_usage[11].avg_energy_charge_per_KWH =
      this.monthlyUsageArr[0].avg_energy_charge_per_KWH;

    const annuvalsavingupdate = document.getElementById('annualsaving');
    const billamountupdate = document.getElementById('billamount');
    const editchartupdate = document.getElementById('chartbottom');
    if (
      annuvalsavingupdate !== null &&
      annuvalsavingupdate.classList.contains('avgvalue') &&
      billamountupdate.classList.contains('avgvalue')
    ) {
      annuvalsavingupdate.classList.remove('avgvalue');
      billamountupdate.classList.remove('avgvalue');
    } else if (
      billamountupdate !== null &&
      billamountupdate.classList.contains('avgvalue')
    ) {
      billamountupdate.classList.remove('avgvalue');
    } else {
      if (annuvalsavingupdate !== null) {
        annuvalsavingupdate.classList.remove('avgvaluemobil');
        billamountupdate.classList.remove('avgvaluemobil');
      } else {
        billamountupdate.classList.remove('avgvaluemobil');
      }
    }
    editchartupdate.classList.remove('chartbottomvalue');
  }

  // To undo or clear the edit
  resetEditValue(type) {
    const editchartclose = document.getElementById('chartbottom');
    const annuvalsavingclose = document.getElementById('annualsaving');
    const billamountclose = document.getElementById('billamount');
    const usage = sessionStorage.getItem('monthlyUsage_recommendation');
    const DefaultUsage = sessionStorage.getItem('DefaultUsage');
    
    // if (!_.isEmpty(usage) && !this.avgValueChanged) {
    //   this.monthlyUsageArr = JSON.parse(usage).current_usage;
    // }
    if (!_.isEmpty(DefaultUsage)) {
      this.monthlyUsageArr = JSON.parse(DefaultUsage);
      this.updategraph(true);
      
    }
    // To disable the buttons
    this.showUndo = false;
    this.showUpdate = false;
    if (type !== 'undo') {
      // for close
      this.showOption = false;
      this.editoption = true;
      editchartclose.classList.remove('chartbottomvalue');
      if (
        annuvalsavingclose !== null &&
        annuvalsavingclose.classList.contains('avgvalue') &&
        billamountclose.classList.contains('avgvalue')
      ) {
        annuvalsavingclose.classList.remove('avgvalue');
        billamountclose.classList.remove('avgvalue');
      } else if (
        billamountclose !== null &&
        billamountclose.classList.contains('avgvalue')
      ) {
        billamountclose.classList.remove('avgvalue');
      } else {
        if (annuvalsavingclose !== null) {
          annuvalsavingclose.classList.remove('avgvaluemobil');
          billamountclose.classList.remove('avgvaluemobil');
        } else {
          billamountclose.classList.remove('avgvaluemobil');
        }
      }
    }
  }

  // To update the chart value
  updateChart(event) {
    debugger
    const value = Number(this.updatedNewValue);
    let updatedMonth;

    // Check the type and assign the data value
    if (!_.isEmpty(this.highChartsOptions.series[1])) {
      this.highChartsOptions.series[1].data[this.selectedIndex].y =
        value *
        Number(
          this.highChartsOptions.series[1].data[this.selectedIndex]
            .avg_energy_charge_per_KWH
        );
      this.highChartsOptions.series[1].data[this.selectedIndex].color =
        '#ffc214';
      updatedMonth =
        this.highChartsOptions.series[1].data[this.selectedIndex].point;
    } else {
      this.highChartsOptions.series[0].data[this.selectedIndex].y =
        value *
        Number(
          this.highChartsOptions.series[0].data[this.selectedIndex]
            .avg_energy_charge_per_KWH
        );
      this.highChartsOptions.series[0].data[this.selectedIndex].color =
        '#ffc214';
      updatedMonth =
        this.highChartsOptions.series[0].data[this.selectedIndex].point;
    }

    // To update the usage and get the recommendation value from backend
    // To update the usage object with the updated value
    let valueUpdated = false;
    if (
      Number(this.recommendationObj.current_usage[this.selectedIndex].usage) !==
      Number(value)
    ) {
      this.recommendationObj.current_usage[this.selectedIndex].usage =
        Number(value);
      valueUpdated = true;
    }

    this.clicks = 0; // after action performed, reset counter
    if (valueUpdated) {
      this.openModal();
      const res_usage = {
        usage_history: this.recommendationObj.current_usage,
        service_type: this.recommendationObj.service_type,
        hg_accountId: this.recommendationObj.hg_accountId,
        avg_price_kwh:
          this.recommendationObj.current_usage[0].avg_energy_charge_per_KWH,
      };
      const body = new HttpParams().append(
        'userResponses',
        JSON.stringify(res_usage)
      );

      this.http
        .post(this.url + '/updateRecommendation', body)
        .subscribe((res: any) => {
          this.updateRecommendationValues(res);
          this.inializeFn();
          setTimeout(() => {
            /** spinner ends after 5 seconds */
            // this.spinner.hide();
            this.onCloseHandled();
          }, 3500);
          // this.updateValue = true;
        });
    } else {
      this.inializeFn();
    }
  }
  // to open the modal
  openModal() {
    this.display = 'block';
  }
  // to close the modal
  onCloseHandled() {
    this.display = 'none';
  }
  // to open the modal
  openModal1() {
    this.display1 = 'block';
  }
  // to close the modal
  onCloseHandled1() {
    this.display1 = 'none';
  }

  @HostListener('window:scroll', ['$event'])
  doSomething(event) {
    this.scrollPosition = window.pageYOffset;
  }

  // Drop-down by default colour #2b2e34 , when select the dropdown colour changed to #ed1976
  selectOnlyThis(id, mobileId, view) {
    const menuOpen1 = document.getElementById('drpmenu1').classList;
    const menuOpen2 = document.getElementById('drpmenu2').classList;
    const menuOpen3 = document.getElementById('drpmenu3').classList;
    const menuOpen4 = document.getElementById('drpmenu4').classList;
    if (
      !(
        menuOpen1.contains('show') ||
        menuOpen2.contains('show') ||
        menuOpen3.contains('show') ||
        menuOpen4.contains('show')
      )
    ) {
      const dropid = document.getElementById(id);
      const blockdrop = document.getElementById(mobileId);
      if (
        !dropid.classList.contains('optenable') &&
        dropid.attributes[1].textContent === 'false'
      ) {
        dropid.classList.add('optenable');
        blockdrop.classList.add('dropblock');
      }

      if (id === 'contractTm' || id === 'contractTmmb') {
        this.selectTerm = true;
      }
    } else {
      document.body.style.overflowY = 'scroll';
      event.stopPropagation();
    }
  }

  // call this to Disable

  selectthis(event, id, view) {
    this.termId = id;
    view === 'Webview'
      ? this.setWebSelectedContractTerm(event)
      : this.setMobileSelectedContractTerm(event);
  }

  setWebSelectedContractTerm(event) {
    let docElement;
    this.idName = 'contractTermwb';
    if (this.termId === this.dropDownValues.length) {
      for (let j = 1; j <= this.dropDownValues.length - 1; j++) {
        docElement = document.getElementById(`contractTermwb${j}`);
        docElement.checked = false;
      }
      docElement = document.getElementById(
        `contractTermwb${this.dropDownValues.length}`
      );
      this.splitData = this.dropDownValues.map((row) => {
        if (row.value !== 1000) return row.value;
      });
      docElement.checked = event.target.checked;
      this.dropDownValues = this.setDropDownObjectValuesForAll('All');
      this.assignTermListDetails(docElement.checked, event.target.value);
    } else {
      docElement = <HTMLInputElement>(
        document.getElementById(`contractTermwb${this.dropDownValues.length}`)
      );
      docElement.checked = false;
      docElement = <HTMLInputElement>(
        document.getElementById(`contractTermwb${this.termId}`)
      );
      docElement.checked = event.target.checked;
      this.assignTermListDetails(docElement.checked, event.target.value);
      this.dropDownValues = this.setDropDownObjectValuesForAll('NoAll');
    }
    
    
      this.saveChanges();
    
    
  }

  setDropDownObjectValuesForAll(itemValue) {
    let drop = [];
    if (itemValue === 'All') {
      this.dropDownValues.map((row) => {
        if (row.value === '1000')
          drop.push({ value: row.value, checked: true });
        else drop.push({ value: row.value, checked: false });
      });
    } else {
      this.dropDownValues.map((row) => {
        this.splitData.includes(row.value)
          ? drop.push({ value: row.value, checked: true })
          : drop.push({ value: row.value, checked: false });
      });
    }
    return drop;
  }

  assignTermListDetails(valueExists, itemValue) {
    if(itemValue == 1000)
       itemValue = 'Compare'

    if (!valueExists) {
      this.splitData = this.splitData.filter((row) => itemValue !== row);
    } else {
      if (this.splitData.length > 0 && !this.splitData.includes(itemValue)) {
        this.splitData.push(itemValue);
      } else {
        this.splitData = [];
        this.splitData.push(itemValue);
      }
    }
    sessionStorage.setItem(
      'selectedProviderData',
      JSON.stringify(this.splitData)
    );
  }

  setMobileSelectedContractTerm(event) {
    let docElement;
    this.idName = 'contractTerm';
    if (this.termId === this.dropDownValues.length) {
      for (let j = 1; j <= this.dropDownValues.length - 1; j++) {
        docElement = document.getElementById(`contractTerm${j}`);
        docElement.checked = false;
      }
      docElement = document.getElementById(
        `contractTerm${this.dropDownValues.length}`
      );
      this.splitData = this.dropDownValues.map((row) => {
        if (row.value !== 1000) return row.value;
      });
      docElement.checked = event.target.checked;
    } else {
      docElement = <HTMLInputElement>(
        document.getElementById(`contractTerm${this.dropDownValues.length}`)
      );
      docElement.checked = false;
      docElement = <HTMLInputElement>(
        document.getElementById(`contractTerm${this.termId}`)
      );
      this.assignTermListDetails(event.target.checked, event.target.value);
    }
  }

  filtershow(dropid) {
    const drpdownvalue = document.getElementById(dropid);
    if (
      drpdownvalue.ownerDocument.activeElement.classList.contains('hidedropdn')
    ) {
      drpdownvalue.classList.remove('disblk');
      drpdownvalue.classList.remove('show');
    } else if (drpdownvalue.classList.contains('dropdown-menu')) {
      drpdownvalue.classList.add('disblk');
    }
  }

  // Mobile view done button click
  doneclrrmove(dropIdd, mobileIDclr, view) {
    const btnclrRemove = document.getElementById(dropIdd);
    if (btnclrRemove.classList.contains('optenable')) {
      btnclrRemove.classList.remove('optenable');
    }
    const blockdropMb = document.getElementById(mobileIDclr);
    blockdropMb.classList.remove('dropblock');
    this.productIndex = 0;
    this.showAllfilters();
    if (dropIdd === 'energyProd' || dropIdd === 'energyProdmb') {
      this.isDoneClicked = true;
      this.checkedListFinal = this.checkedList;
    }
    this.providersCount = this.setSelectedEnergyProviders(
      this.energyProviderList
    );
  }
  providersCheckedListCount(): number {
    return this.checkedList.includes('Show All')
      ? this.checkedList.length - 1
      : this.checkedList.length;
  }

  doneclrrmoverenewable() {
    if (this.renewableEnergyValue1 || this.renewablemb1) {
      this.recommendations = [];
      for (
        let i = 0;
        i < this.recommendationObj.res_products_recommendations.length;
        i++
      ) {
        for (let j = 0; j < this.checkedList.length; j++) {
          for (let k = 0; k < this.splitData.length; k++) {
            if (
              this.recommendationObj.res_products_recommendations[
                i
              ].terms.toString() === this.splitData[k] &&
              this.recommendationObj.res_products_recommendations[i]
                .energy_provider === this.checkedList[j]
            ) {
              this.recommendations.push(
                this.recommendationObj.res_products_recommendations[i]
              );
            }
          }
        }
      }
      if (this.recommendations.length > 0) {
        if (this.splitData.length > 1) {
          this.prerecommendation = _.uniq(
            this.recommendations,
            function (value) {
              return value.terms.toString();
            }
          );

          let fin = _.uniq(this.prerecommendation, function (value) {
            return (value.new_tier.ave_price_per_KWH * 100).toFixed(1);
          });

          this.prerecommendation = fin;
        } else {
          this.prerecommendation = this.recommendations;
        }
        this.prerecommendation.forEach((item, index, destArr) => {
          if (item.description) {
            let arr = item.description.split(' ');
            let tempArr = arr.slice(arr.length - 2, arr.length);
            destArr[index]['productSecondName'] = tempArr
              .join(' ')
              .toUpperCase();
          }
        });
      } else {
        this.noproduct = true;
      }
    } else if (this.renewableEnergyValue2 || this.renewablemb2) {
      let finaldataVal = _.filter(this.recommendations, function (value) {
        return value.Renewable === 100;
      });
      if (finaldataVal.length != 0) {
        this.recommendations = finaldataVal;
      }
      if (finaldataVal.length === 0) {
        this.noproduct = true;
      } else {
        this.noproduct = false;
      }
      if (this.recommendations.length > 0) {
        if (this.splitData.length > 1) {
          this.prerecommendation = _.uniq(
            this.recommendations,
            function (value) {
              return value.terms.toString();
            }
          );

          let fin = _.uniq(this.prerecommendation, function (value) {
            return (value.new_tier.ave_price_per_KWH * 100).toFixed(1);
          });

          this.prerecommendation = fin;
        } else {
          this.prerecommendation = this.recommendations;
        }
        // this.prerecommendation = this.recommendations;
        this.prerecommendation.forEach((item, index, destArr) => {
          if (item.description) {
            let arr = item.description.split(' ');
            let tempArr = arr.slice(arr.length - 2, arr.length);
            destArr[index]['productSecondName'] = tempArr
              .join(' ')
              .toUpperCase();
          }
        });
        this.recommendProduct = this.recommendations[0];
        this.assignActiveClassToRecommendProduct();
      } else {
        this.noproduct = true;
      }
    }
  }

  onfreeze() {
    //let iddd = document.getElementById('chartfixed');
    //iddd.classList.add('chartfixedForScroll');
    //this.scrollofChart = true;
    // $(".chartcontainer").addClass('chartfixednew')
    // if($('.chartfixedForScroll').length != 0 && $('#chartfixed').css('top') == "0px")
    // {
    //     $(".product-list").css("padding-top", $("#chartfixed").height() + 20)

    // }
  }

  offfreeze() {
    // let iddd = document.getElementById('chartfixed');
    // iddd.classList.remove('chartfixedForScroll');
    // this.scrollofChart = false;
    // $(".chartcontainer").removeClass('chartfixednew')
    // $(".product-list").css("padding-top", 0)
  }

  resiClickdrop(event) {
    console.log(event.target.checked);

    const residentialRadio = <HTMLInputElement>(
        document.getElementById('renewablewb2')
      ),
      residentialRadio1 = <HTMLInputElement>(
        document.getElementById('renewablewb1')
      ),
      residentialRadio2 = <HTMLInputElement>(
        document.getElementById('renewablewb3')
      );

    const renewablemb1 = <HTMLInputElement>(
      document.getElementById('renewablemb1')
    );
    const renewablemb2 = <HTMLInputElement>(
      document.getElementById('renewablemb2')
    );
    this.renewableEnergyValue1 = residentialRadio.checked;
    this.renewableEnergyValue2 = residentialRadio1.checked;

    this.renewablemb1 = renewablemb1.checked;
    this.renewablemb2 = renewablemb2.checked;
  }

  resiClickdropProduct(ev) {
    const prepaidwb1 = <HTMLInputElement>document.getElementById('prepaidwb11');
    const prepaidwb2 = <HTMLInputElement>document.getElementById('prepaidwb22');
    this.prepaidwb1 = prepaidwb1.checked;
    this.prepaidwb2 = prepaidwb2.checked;
  }

  doneclrrmoveProduct() {
    if (this.splitData.length === 0) this.splitData = this.dropDownValues;
    this.recommendations = [];
    this.assignPreRecommendationValues();
    this.validateRecommendationsForSelectedData();
    this.filterRecommendationsPerRenewable();
    // this.recommendations = this.assignRecommendationsForProductTypes();
    if (this.recommendations.length === 0) {
      this.noproduct = true;
      this.recommendations = this.prerecommendation;
      return;
    }
    if (this.recommendations.length > 0) {
      this.noproduct = false;
      if (this.splitData.length > 1) {
        this.recommendations = this.sortValuesPerAveragePricePerKwh(
          this.recommendations
        );
        this.prerecommendation = this.recommendations;
      } else {
        this.prerecommendation = this.recommendations;
      }
      window.dispatchEvent(new Event('resize'));
    }
  }

  filterRecommendationsPerRenewable() {
    let recommend = [];
    if (this.productTypes.includes('100')) {
      this.prerecommendation.map((row) => {
        if (parseInt(row.Renewable) === 100) recommend.push(row);
      });
      this.prerecommendation = recommend;
      this.recommendations = this.prerecommendation;
    } else this.recommendations = this.assignRecommendationsForProductTypes();
  }
  assignRecommendationsForProductTypes() {
    let recommend;
    this.productTypes.map((row) => {
      const item = this.recommendations.filter(
        (itemValue) => itemValue.ProductType === row
      );
      if (recommend) {
        recommend = [...recommend, ...item];
      } else {
        recommend = item;
      }
    });
    return recommend;
  }

  private applyRecommendationFilters() {
    this.recommendations = [];
    


    setTimeout(()=>{       
      this.assignSplitDataFiltersBased();
      this.assignPreRecommendationValues();
      this.validateRecommendationsForSelectedData();
      //this.prerecommendation = this.recommendations;
      if (this.swipedId === undefined) this.swipedId = this.productIndex;
      if (this.prepaidwb4) this.doneclrrmoveProduct();
      this.assignActiveClassToRecommendProduct();
      this.graphSelectedProduct = this.recommendations[this.productIndex];
      this.updateProductChart = true;
      this.changeBarChart(this.graphSelectedProduct);
  
      const Providerlist_ = document.querySelectorAll('.providersDiv');
      if(Providerlist_.length > 1)
      {
        document.getElementById(Providerlist_[0].id)
        .classList.remove('active');
      }

     
      this.currentPage = 0;
      this.setEnergyProvidersRecordSet(this.currentPage);
   
    }, 100);

    
   



    setTimeout(()=>{                          
     
      this.changeIUsageGraph(
        this.recommendations[this.productIndex],
        this.productIndex,true
      );


    }, 100);

  
  }
 
  // To Calculate the width for the bar
  calculateWidth(productObj) {
    // To calculate the maximum value

    if (!_.isEmpty(this.recommendations)) {
      const maxProductObj = _.max(this.recommendations, function (row) {
        if (row !== undefined && row.new_tier !== undefined)
          return row.new_tier.ave_price_per_KWH;
      });

      // const minProductObj = _.min(this.recommendations, function (row) {
      //   if (row !== undefined && row.new_tier !== undefined)
      //     return row.new_tier.ave_price_per_KWH;
      // });

      const minProductObj = _.min(this.preSelectedRecords, function (row) {
        if (row !== undefined && row.new_tier !== undefined)
          return row.new_tier.ave_price_per_KWH;
      });

      var aa = this.preSelectedRecords;
      
      var min = Number(minProductObj.new_tier.ave_price_per_KWH * 100).toFixed(1);
      var current = Number(productObj.new_tier.ave_price_per_KWH * 100).toFixed(1);
      var diff =  Number((Number(current) - Number(min)).toFixed(1)) * 5;

    //  var px = 0;
    //   if(diff == 0.1)
    //   {
    //     px = 3;

    //   }
    //   else
    //   {
    //     c
     // }
      var value = 7 * diff;

      var percentage = value;
      
      const maxVal = Number(maxProductObj.new_tier.ave_price_per_KWH);
      const currentVal = Number(this.getNewTierPricePerKwh(productObj));
       
      
      // var adjust = 0;
      // var v = (currentVal);
      // var a = (currentVal * 100);
      // if(this.OldEG_.toFixed(1) < a.toFixed(1))
      // {
      //   adjust = 1;
      // }


   

      // var percentage = currentVal * 100;

      // percentage = percentage + adjust;
      


      // if(this.OldEG_.toFixed(1) == a.toFixed(1) && this.olpercentage != 0)
      // {
      //   percentage = this.olpercentage;
      // }

      // this.oldEGValue = currentVal;
      // this.OldEG_ = currentVal * 100;
      
      // this.olpercentage = percentage;

      // if((percentage + 55 ) > 100)
      // {
      //   percentage = 45;

      // }
      // var percentage = Math.floor((currentVal / maxVal) * 100);
      return this.deviceWidth > 678
        ? percentage + 350 + 'px'
        : percentage + 350 + 'px';
    }
  }

  getNewTierPricePerKwh(productObj) {
    if (productObj !== undefined && productObj.new_tier !== undefined)
      return productObj.new_tier.ave_price_per_KWH;
  }

  changeIUsageGraphbyProduct(productObj,IsUpdateChart) {
    var index = this.recommendations.findIndex(
      (x) => x.ProductID === productObj.ProductID
    );
    this.graaphLabelName = this.assignEnergyProvidersLabelName(index);
    // this.onfreeze();
    this.changeIUsageGraph(this.recommendations[index], index, IsUpdateChart);
  }

  // To change the usgae graph
  changeIUsageGraph(productObj, i, IsUpdateChart) {
    const id =
      productObj.product_key +
      (productObj.new_tier.ave_price_per_KWH * 100).toFixed(1);
    this.graaphLabelName = this.assignEnergyProvidersLabelName(i);
    // To hide the edit option
    this.showOption = false;
    // set the selected index value for right side graph value change
    this.productIndex = i;
    this.scrollActiveIndex = i;

    // Remove disableborder class for existing element and add for the  - For product list planratt planrate bdrbotmb
   
  var value  = ((i == "" ? 1 : i ) + 1 )/ 5;
  if(value.toString().indexOf('.') > -1)
  {
    var split = (Number(value.toString().split('.')[0])) * 5
    this.setEnergyProvidersRecordSet(split);
    this.currentPage = split;
  }
  else
  {
    value = (value -1) * 5;
    this.currentPage = value;
    this.setEnergyProvidersRecordSet(value);
  }


   

    const allElem = document.querySelectorAll('.plansummary');

    for (let k = 0; k < allElem.length; k++) {
      if (allElem[k] !== null && allElem[k].id != "") {
        //allElem[k].classList.add('disableborder');
      document.getElementById(allElem[k].id)
      .classList.add('disableborder');

        allElem[k].firstElementChild.classList.remove('bdrbotmb');
      }
    }
 

    // if (!this.cd['destroyed']) {
    //   this.cd.detectChanges();
    // }

     const element = document.getElementById(productObj.ProductID);
     if (element !== null) {
       if (!element.classList.contains('active'))
         element.classList.add('active');
     }
    const currentActiveElement = document.querySelector('#prductListObj' + i);
    // change the text abd highlight the label heading
    //if (Number(i) !== Number(0)) {
      document.querySelector('#productHead0').classList.remove('clrpink');

      const Providerlist_ = document.querySelectorAll('.providersDiv');
      for (let k = 0; k < Providerlist_.length; k++) {
        if (Providerlist_[k] !== null && productObj.ProductID != Providerlist_[k].id) {
          //allElem[k].classList.add('disableborder');
         document.getElementById(Providerlist_[k].id)
         .classList.remove('active');
  
          }
      }
      // const Providerlist__ = document.querySelectorAll('.providersDiv');
      // for (let k = 0; k < Providerlist__.length; k++) {
       
      //  const ele = Providerlist_[k].classList.forEach(function(i,v){

      //   if(i == "active")
      //   {
      //     document.getElementById(Providerlist_[k].id)
      //     .classList.add('active');
      //   }
      
  

      //  });
     
  
      // }
      //
      var r = document
        .getElementById('singleObj' + (i));
        if(r != null)
        {
          r.classList.remove('disableborder');

        }
      this.selectHeading = '';
    // } else if (Number(i) == Number(0)) {
    //   // const singleObj = document.getElementById('singleObj');
    //   // singleObj.classList.remove('disableborder');

      
 
    // }
    // else
    // {
     

    // }

    if(i == 0)
    {
      var a = this.deviceWidth;
      i = "";
      setTimeout(function(){

        try{
          const singleObj = document.getElementById('singleObj0');
          singleObj.classList.remove('disableborder');

        }catch{

        }
  
       },100)
     }
    // else
    // {
    //   i = (i - 1);
    // }


   i = (i);

    if(IsUpdateChart == true)
    {
      
      var old = this.ChartProductId;
      this.graphSelectedProduct = productObj;
      this.updateProductChart = true;
      this.changeBarChart(productObj);
      this.ShowChart = true
      this.ChartProductId = productObj.ProductID

      if(this.ShowChart && old == productObj.ProductID)
      {
        this.ShowChart = false;
        this.ChartProductId =0;
      }
    }
   

    if (
      $('#singleObj' + (i)).offset() !== undefined &&
      $('#singleObj' + (i)).offset().top !== undefined
    ) {


      var scroll = 100;

   

      if(this.scrollofChart == true)
      {
        $(".chartcontainer").addClass('chartfixednew')
        scroll = scroll + $("#chartfixed").height()
  
      }

      if($(window).scrollTop() <= 300)
      {
        //scroll = scroll + 500;
      }

      // if(this.ShowChart == false)
      // {
        $('html, body').animate(
          { scrollTop: $('#singleObj' + (i)).offset().top - scroll },
          200
        );
      //}

     
    }

    window.dispatchEvent(new Event('resize'));
  }
  ShowChart = false;
  ChartProductId = 0;

  assignEnergyProvidersLabelName(i): any {
    return `${this.recommendations[i].terms} ${this.recommendations[
      i
    ].energy_provider.toUpperCase()}-${this.recommendations[
      i
    ].product_key.toUpperCase()}`;
  }

  orderProduct(singleObj) {
    this.recommendationService.signupProduct = singleObj;
    sessionStorage.setItem(
      'currentUsageUpdates',
      JSON.stringify(this.recommendationObj.current_usage)
    );
    const accountId = this.recommendationService.hg_accountId;
    this.residentialService.validateHGAccountID(accountId)
      ? this.submitOrderProductDetails()
      : this.submitOrderProductDetails();
      
      var zipcode ="";
      var a = JSON.parse(sessionStorage.getItem('widthoutQuestionUserRequest'))
      if(a != null && a != undefined)
      {
        zipcode = a.zipcode;
      }

      CallTrack_function(
        "CompareProduct",
        singleObj.energy_provider, 
        singleObj.product_key, 
        singleObj.terms, 
        (singleObj.tier[0].avg_charge * 100).toFixed(1),
        (singleObj.tier[1].avg_charge * 100).toFixed(1),
        (singleObj.tier[2].avg_charge * 100).toFixed(1),
        zipcode,  
        singleObj.utility_name, 
        "",
        "" );

      // window.sendinblue.track(

      //   'CompareProduct', "" ,
      
      //   {
      
      //     "REP": singleObj.energy_provider,
      
      //     "Product_Name" : singleObj.product_key,
      
      //     "Contract_Term" : singleObj.terms,
      
      //     "Price_500" :  (singleObj.usageObj[0].avg_charge * 100).toFixed(1),
      
      //     "Price_1000" :(singleObj.usageObj[1].avg_charge * 100).toFixed(1),
      
      //     "Price_2000" : (singleObj.usageObj[2].avg_charge * 100).toFixed(1),
      
      //     "Zip" : zipcode,
      
      //     "TDSP" : singleObj.utility_name
      
      //   }
      
      // );

      // $.fn.testFunction()
  }

  submitOrderProductDetails() {
    const accountId = this.recommendationService.hg_accountId = '630263ecc136af6d90660307';
    const energyProviderName =
        this.recommendationService.signupProduct.energy_provider,
      utilityName = this.recommendationService.signupProduct.utility_name,
      planName = this.recommendationService.signupProduct.product_key,
      productID = this.recommendationService.signupProduct.ProductID;

    this.residentialService
      .getEnergyProvidersPlanStatus(energyProviderName, utilityName, planName)
      // .subscribe(
      //   (res: any) => {
      //     if (
      //       res.length > 0 &&
      //       productID !== res[0].ProductID &&
      //       this.residentialService.validateCreatedDateTime(res[0].createdDate)
      //     ) {
      //       this.assignNewEnergyProvidersRates();
      //     } else {
      //       this.navigateEnergyPlanConfirmation();
      //     }
      //   },
      //   (err) => {
      //     this.navigateEnergyPlanConfirmation();
      //   }
      // );
      .subscribe(
        (res: any) => {
          this.checkEnergyProvidersApiPlanStatus(res, productID);
        },
        (err) => {
          this.getUserDetails();
        }
      );
  }

  navigateEnergyPlanConfirmation() {
      this.router.navigate([
        'energyplan-confirmation',
        this.recommendationService.hg_accountId,
      ]);
    }
    
  openNewEnergyRatesModal(template: ElementRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-small' })
    );
  }

  newEnergyProviderRates() {
    sessionStorage.setItem(
      'currentUser',
      this.recommendationService.hg_accountId
    );
    this.modalRef.hide();
    this.router.navigate([
      'recommendation/compare-product',
      this.recommendationService.hg_accountId,
    ]);
  }

  assignNewEnergyProvidersRates() {
    const user = {
      esiid: null,
      questionStatusObj: sessionStorage.getItem('questionStatusObj'),
      questionnarieObj: JSON.parse(sessionStorage.getItem('userResponse')),
    };
    this.residentialService.getRecommendations(user).subscribe((result) => {
      this.recommendationService.recommendationObj =
        result['recommendedProduct'];
      sessionStorage.setItem(
        'recommendedProducts',
        JSON.stringify(result['recommendedProduct'])
      );
      this.openNewEnergyRatesModal(this.newEnergyRates);
    });
  }

  // Edit chart usage
  openEditUsage(event) {
    const editchartvalue = document.getElementById('chartbottom');
    const annuvalsavingvalue = document.getElementById('annualsaving');
    const billamountvalue = document.getElementById('billamount');
    let userres = JSON.parse(sessionStorage.getItem('userResponse'));

    if (this.recommendationObj.current_usage[0].avg_energy_charge_per_KWH) {
      this.avg_price_kwh =
        this.recommendationObj.current_usage[0].avg_energy_charge_per_KWH !=
          undefined &&
        this.recommendationObj.current_usage[0].avg_energy_charge_per_KWH.split(
          '.'
        )[1]
          ? this.recommendationObj.current_usage[0].avg_energy_charge_per_KWH.split(
              '.'
            )[1]
          : this.recommendationObj.current_usage[0].avg_energy_charge_per_KWH;
    }
  
    this.onFocus();

    this.showOption = true;
    this.editoption = false;
    // editchartvalue.classList.add('chartbottomvalue');
    if (event.view.innerWidth <= 575) {
      if (annuvalsavingvalue !== null) {
        annuvalsavingvalue.classList.add('avgvaluemobil');
      }
      billamountvalue.classList.add('avgvaluemobil');
    } else {
      if (annuvalsavingvalue !== null) {
        annuvalsavingvalue.classList.add('avgvalue');
      }
      billamountvalue.classList.add('avgvalue');
    }
  }

  getAllPlanDetails() {
    var puctValue = this.recommendationObj.res_products_recommendations[0].puct;
    this.deviceWidth = window.innerWidth;

    const scrollTo = document.getElementById('prductListObj0').offsetHeight;
    window.scrollTo(0, 180);
    if (this.deviceWidth < 500) window.scrollTo(0, 900);

    var d = document.getElementById('getAllPlans');
    if (d.className.includes('disabled')) {
      d.className = 'isEnabled';
      this.allRecommendations = [];
    } else {
      d.className += 'disabled';
    }
  }

  showAllfilters() {
    this.recommendations = [];
    this.assignSplitDataFiltersBased();
    this.assignPreRecommendationValues();
    this.validateRecommendationsForSelectedData();
    if (this.prepaidwb4) this.doneclrrmoveProduct();
    if (this.recommendations.length > 0) {
      this.assignActiveClassToRecommendProduct();
      this.changeIUsageGraph(this.recommendations[0], 0,true);
    }
  }

  validateRecommendationsForSelectedData() {
    this.noproduct = false;
    if (this.recommendations.length === 0) {
      this.noproduct = true;
      if (this.residentialService.preRecommendation) {
        this.recommendations = this.residentialService.preRecommendation;
      } else {
        this.recommendations = this.prerecommendation;
        sessionStorage.setItem('preRecommend', this.prerecommendation);
        this.residentialService.preRecommendation = this.prerecommendation;
      }
    }
  }
  assignSplitDataFiltersBased() {
    this.splitData = _.uniq(this.splitData, function (value) {
      return value;
    });
  }

  selectthisEnergyProvider(id) {
    let energshowall;
    var energ = <HTMLInputElement>document.getElementById('energyObj' + id);
    if (id === this.energyProviderList.length) {
      this.energyProviderList = this.energyProviderList.map((value) => {
        return this.getEnergyCheckedListObj(value);
      });
      this.checkedList = this.getAllEnergyProvidersList();
      sessionStorage.setItem(
        'selectedEnergyProvider',
        JSON.stringify(this.checkedList)
      );
    } else if (id != this.energyProviderList.length) {
      energshowall = <HTMLInputElement>(
        document.getElementById('energyObj' + this.energyProviderList.length)
      );
      energshowall.checked = false;


      this.energyProviderList[this.energyProviderList.length - 1].checked = false;

      energshowall = document.getElementById(`energyObj${id}`);
      var checked = true;
      if(energshowall.checked.toString() === "true")
      {
        checked = false;
      }
      energshowall = document.getElementById(`energyObj${id}`);
      const checkValue = this.assignEnergyProviderListDetails(
        checked,
        id
      );
      energshowall.checked = checkValue;
    }

    if (this.deviceWidth > 768) {
      this.saveChanges();
    }
  }

  selectMobEnergyProvider(id, event) {
    console.log(event.target.checked);
    console.log(event.target.value);

    let energshowall;

    const productIndex = this.energyProviderList.findIndex(
      (row) => row.value === event.target.value
    );
    if (productIndex === this.energyProviderList.length - 1) {
      this.checkedListFinal = this.getAllEnergyProvidersList();
      this.providersCount = this.checkedListFinal.length - 1;
      this.energyProviderList = this.energyProviderList.map((row) => {
        return this.getEnergyCheckedListObj(row);
      });
    } else {
      this.energyProviderList[productIndex].checked = event.target.checked;
      this.energyProviderList[this.energyProviderList.length - 1].checked =
        false;
      this.checkedListFinal = this.setSelectedEnergyProviders(
        this.energyProviderList
      );
    }
  }

  setSelectedEnergyProviders(itemValue) {
    this.providersCount = 0;
    return itemValue.map((row) => {
      if (row.checked === true) {
        this.providersCount += 1;
        return row.value;
      }
    });
  }

  selectthisMobEnergyProvider(id, event) {
    console.log(event.target.checked);

    let energshowall;
    if (id === this.energyProviderList.length) {
      this.energyProviderList = this.energyProviderList.map((value) => {
        return this.getEnergyCheckedListObj(value);
      });
      this.checkedList = this.getAllEnergyProvidersList();
      sessionStorage.setItem(
        'selectedEnergyProvider',
        JSON.stringify(this.checkedList)
      );
    } else if (id != this.energyProviderList.length) {
      energshowall = document.getElementById(
        `energyObjMob${this.energyProviderList.length}`
      );
      energshowall.checked = false;
      energshowall = document.getElementById(`energyObjMob${id}`);
      const checkValue = this.assignEnergyProviderListDetails(
        energshowall.checked,
        id
      );
      energshowall.checked = checkValue;
    }
  }

  assignEnergyProviderListDetails(valueExists, itemValue) {
    if (!valueExists) {
      if (
        this.checkedList.length === this.energyProviderList.length - 1 ||
        this.checkedList.length - 1 === this.energyProviderList.length - 1
      ) {
        this.checkedList = [];
        this.checkedList.push(this.energyProviderList[itemValue - 1].value);
      } else {
        if (!this.checkedList.includes(itemValue - 1)) {
          this.checkedList.push(this.energyProviderList[itemValue - 1].value);
        } else {
          this.checkedList.splice(itemValue - 1, 1);
        }
      }
      if (this.deviceWidth > 768)
        sessionStorage.setItem(
          'selectedEnergyProvider',
          JSON.stringify(this.checkedList)
        );
      return true;
    } else {
      if (this.checkedList.length === this.energyProviderList.length) {
        this.checkedList = [];
        this.checkedList.push(this.energyProviderList[itemValue - 1].value);
      } else {
        if (
          !this.checkedList.includes(
            this.energyProviderList[itemValue - 1].value
          )
        ) {
          this.checkedList.push(this.energyProviderList[itemValue - 1].value);
        } else {
          this.checkedList = this.checkedList.filter(
            (row) => row !== this.energyProviderList[itemValue - 1].value
          );
        }
      }
      if (this.deviceWidth > 768)
        sessionStorage.setItem(
          'selectedEnergyProvider',
          JSON.stringify(this.checkedList)
        );
      return false;
    }
  }

  getAllEnergyProvidersList(): any[] {
    return this.energyProviderList.map((value) => {
      return value.value;
    });
  }

  cbChange(event, value) {
    this.renewableEnergyValue3 = false;
    if (value === 'RenewableOnly')
      this.renewableEnergyValue1 = event.target.checked;
    if (value === 'NoDeposit')
      this.renewableEnergyValue2 = event.target.checked;
    if (value === 'showAll') {
      this.renewableEnergyValue1 = false;
      this.renewableEnergyValue2 = false;
      this.renewableEnergyValue3 = true;
    }

    sessionStorage.setItem('selectedFeatureData', value);
  }

  // To select the energy poviders - Filter
  getSelectedEnergyProvider(selectedEnergy, event) {
    this.isDoneClicked = false;
    if (event.target.checked) {
      if (selectedEnergy.value === 'Show All')
        this.getEnergyProviderListWhenShowAll(selectedEnergy);
      else this.getEnergyProviderListWhenNotShowAll(selectedEnergy);
    } else {
      this.unCheckSelectedEnergyProviderList(selectedEnergy);
    }
    sessionStorage.setItem(
      'selectedEnergyProvider',
      JSON.stringify(this.checkedList)
    );
  }
  getEnergyProviderListWhenNotShowAll(selectedEnergy: any) {
    if (!this.checkedList.includes(selectedEnergy.value))
      this.checkedList.push(selectedEnergy.value);
    else {
      this.checkedList = [];
      this.checkedList.push(selectedEnergy.value);
    }
  }

  getEnergyProviderListWhenShowAll(selectedEnergy) {
    const finalArray = this.energyProviderList.map((value) => {
      return {
        checked: value.value !== selectedEnergy.value ? false : true,
        value: value.value,
        name: 'option1',
        product_key: value.product_key,
      };
    });
    this.energyProviderList = finalArray;
    this.checkedList = this.getAllEnergyProvidersList();
  }

  unCheckSelectedEnergyProviderList(selectedEnergy) {
    this.checkedList.map((row, i) => {
      if (row === selectedEnergy.value) {
        if (selectedEnergy.value != 'Show All') {
          this.checkedList.splice(i, 1);
        }
      }
    });
  }

  // Check the value exists in the energy provider filter
  checkEnergyValueExist() {
    if (
      this.isDoneClicked &&
      this.recommendationObj &&
      this.recommendationObj.res_products_recommendations
    ) {
      const productList = _.uniq(
        this.recommendationObj.res_products_recommendations.map(
          (a) => a.energy_provider
        )
      );
      const differnceArr = _.difference(productList, this.checkedList);
      const idxLst = [];
      for (
        let i = 0;
        i < this.recommendationObj.res_products_recommendations.length;
        i++
      ) {
        const enrgy_val =
          this.recommendationObj.res_products_recommendations[i]
            .energy_provider;
        const filterEnergyProviderEle = document.getElementById(
          this.recommendationObj.res_products_recommendations[i].product_key
        );
        const filterProductCardEle = document.getElementById(
          'prductListObj' + i
        );
        for (let j = 0; j < differnceArr.length; j++) {
          if (enrgy_val === differnceArr[j]) {
            filterEnergyProviderEle.classList.add('hide');
            filterProductCardEle.classList.add('hide');
            this.hiddenProviders.push(differnceArr[j]);
            if (Number(i) === Number(0)) {
              this.activeIdx = Number(i) + Number(1);
            } else {
              if (this.activeIdx === Number(i)) {
                this.activeIdx = Number(i) + Number(1);
              }
            }
          }
        }

        // Remove the selected provider's hidden state
        const showProviders = _.difference(this.hiddenProviders, differnceArr);
        for (let k = 0; k < showProviders.length; k++) {
          if (enrgy_val === showProviders[k]) {
            const idx = Number(showProviders[k]);
            const filterEnergyProviderEle1 = document.getElementById(
              this.recommendationObj.res_products_recommendations[i].product_key
            );
            const filterProductCardEle1 = document.getElementById(
              'prductListObj' + i
            );
            filterEnergyProviderEle.classList.remove('hide');
            filterProductCardEle.classList.remove('hide');
            if (Number(i) === Number(0)) {
              this.activeIdx = Number(i);
            } else {
              if (this.activeIdx > Number(i)) {
                this.activeIdx = Number(i);
              }
            }
          }
        }
      }
      // To load the active state
      this.changeIUsageGraph(
        this.recommendationObj.res_products_recommendations[this.activeIdx],
        this.activeIdx,true
      );
    }
  }

  onSwipe(evt, id, swipedOne) {
    if (evt.deltaX > 0) {
      this.seeDetailShow = false;
    } else {
      this.selectedTerm = id;
      this.seeDetailShow = true;
      this.showDetal = false;
      this.swipedId = swipedOne;
    }
  }

  onFocus() {
    this.label = '$0.';
    this.placeholder = '';
  }

  addClass() {
    if (this.avg_price_kwh != undefined) {
      this.recommendationObj.current_usage[0].avg_energy_charge_per_KWH =
        this.avg_price_kwh;
      this.recommendationObj.current_usage[1].avg_energy_charge_per_KWH =
        this.avg_price_kwh;
      this.recommendationObj.current_usage[2].avg_energy_charge_per_KWH =
        this.avg_price_kwh;
      this.recommendationObj.current_usage[3].avg_energy_charge_per_KWH =
        this.avg_price_kwh;
      this.recommendationObj.current_usage[4].avg_energy_charge_per_KWH =
        this.avg_price_kwh;
      this.recommendationObj.current_usage[5].avg_energy_charge_per_KWH =
        this.avg_price_kwh;
      this.recommendationObj.current_usage[6].avg_energy_charge_per_KWH =
        this.avg_price_kwh;
      this.recommendationObj.current_usage[7].avg_energy_charge_per_KWH =
        this.avg_price_kwh;
      this.recommendationObj.current_usage[8].avg_energy_charge_per_KWH =
        this.avg_price_kwh;
      this.recommendationObj.current_usage[9].avg_energy_charge_per_KWH =
        this.avg_price_kwh;
      this.recommendationObj.current_usage[10].avg_energy_charge_per_KWH =
        this.avg_price_kwh;
      this.recommendationObj.current_usage[11].avg_energy_charge_per_KWH =
        this.avg_price_kwh;
    } else if (this.avg_price_kwh == undefined) {
      this.avg_price_kwh =
        this.recommendationObj.current_usage[0].avg_energy_charge_per_KWH;
    }
    if (
      !_.isEmpty(this.avg_price_kwh) &&
      this.avg_price_kwh !== '00' &&
      Number(this.avg_price_kwh) !== 0
    ) {
      this.iskwh = true;
      this.user_bot = true;
      this.avg_price_kwh = this.avg_price_kwh;
      this.label = '$0.';
      this.placeholder = '';
    } else {
      this.user_bot = false;
      this.iskwh = false;
      this.avg_price_kwh = this.avg_price_kwh;
      this.label = '$0.';
      this.placeholder = '';
    }
  }

  onSwipe1(evt) {
    if (Math.abs(evt.deltaX) > 40) {
      if (evt.deltaX < 0) {
        if (this.state === this.maxState) {
          this.state = 0;
        } else {
          this.state++;
          this.leftyarrow = true;
          this.rightyArrow = false;
          const valueForShadow = document.getElementById('shadowProcess');
          valueForShadow.classList.remove('shadow-after');
          valueForShadow.classList.add('shadow-before');
        }
        $('.container_element').animate(
          { scrollLeft: (this.winWidth - 100) * this.state + 'px' },
          800
        );
      } else {
        if (this.state === 0) {
          this.state = this.maxState;
        } else {
          this.state--;
          this.leftyarrow = false;
          this.rightyArrow = true;
          const valueForShadowleft = document.getElementById('shadowProcess');
          valueForShadowleft.classList.remove('shadow-before');
          valueForShadowleft.classList.add('shadow-after');
        }
        $('.container_element').animate(
          { scrollLeft: (this.winWidth - 100) * this.state + 'px' },
          800
        );
      }
    }
  }

  // Edit -chart click
  monthvalueclick(month) {
    this.monthactive = month.month + 'true';
  }

  // add point to chart serie
  add() {
    this.chart.addPoint(Math.floor(Math.random() * 10));
  }

  dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      if (sortOrder == -1) {
        return b[property].localeCompare(a[property]);
      } else {
        return a[property].localeCompare(b[property]);
      }
    };
  }

  assignTermPerEnergyProvider(terms: string, categoryName: string) {
    if (
      this.selectedProductValue.energy_provider === 'Pronto Power' ||
      this.selectedProductValue.energy_provider === 'Bulb'
    ) {
      return `Monthly ${categoryName}`;
    } else {
      return `${terms} Months ${categoryName}`;
    }
  }

  earlyCancellationPopUp() {
    this.openNewEnergyRatesModal(this.earlyCancellationPopup);
  }

  closePopupModel() {
    this.modalRef.hide();
  }

  openPlanDetails(singleObj) {
    this.productKeyTitle = `${singleObj.energy_provider} - ${singleObj.product_key}`;
    this.productTitle = singleObj.energy_provider;
    this.avgCharge500 = Number(singleObj.tier[0].avg_charge * 100).toFixed(2);
    this.avgCharge1000 = (singleObj.tier[1].avg_charge * 100).toFixed(2);
    this.avgCharge2000 = (singleObj.tier[2].avg_charge * 100).toFixed(2);
    this.recommendedEnergyCharge = singleObj.energy_charge;
    this.recommendedBaseFee =
      singleObj.base_fee !== null
        ? singleObj.base_fee > 0
          ? singleObj.base_fee
          : singleObj.base_fee.toString().substring(1)
        : 0;
    if (singleObj.base_fee_limit)
      this.recommendedBaseUsageLimit =
        singleObj.base_fee_limit.search('undefined') > 0
          ? `>=${singleObj.base_fee_limit.substring(
              0,
              singleObj.base_fee_limit.indexOf('undefined') - 1
            )}`
          : singleObj.base_fee_limit;
    this.recommendedTduCharge = Number(singleObj.tdu_delivery_charge).toFixed(
      2
    );
    this.recommendedTduDeliveryCharge = singleObj.tdu_delivery_charge_per_kwh;
    this.averageMonthlyUsage = Math.floor(singleObj.new_tier.ave_monthly_usage);
    this.avgPricePerKWH = Number(
      singleObj.new_tier.ave_price_per_KWH * 100
    ).toFixed(1);
    this.avgMonthlyBill = singleObj.new_tier.ave_monthly_bill;
    this.recommendedUsageCreditFee =
      singleObj.usage1Charge !== undefined ? singleObj.usage1Charge : 0;
    this.recommendedUsageCreditLimit = `${singleObj.usage1} - ${singleObj.usage2}`;
    this.monthlyEstimates = [
      Number(
        Number(singleObj.energy_charge * 500) +
          Number(singleObj.tdu_delivery_charge) +
          Number(singleObj.tdu_delivery_charge_per_kwh * 500)
      ).toFixed(2),
      Number(
        Number(singleObj.energy_charge * 1000) +
          Number(singleObj.tdu_delivery_charge) +
          Number(singleObj.tdu_delivery_charge_per_kwh * 1000)
      ).toFixed(2),
      Number(
        Number(singleObj.energy_charge * 2000) +
          Number(singleObj.tdu_delivery_charge) +
          Number(singleObj.tdu_delivery_charge_per_kwh) * 2000
      ).toFixed(2),
    ];
    this.openNewEnergyRatesModal(this.planDetailsPopup);
  }

  showFilterCard() {
    this.showFilters = !this.showFilters;
    this.showSingleObjDetails = false;
  }

  showFirstCardClick()
  {

    this.ShowChart = false;
    this.ChartProductId =0;
    this. showFirstCard = !this.showFirstCard;
    this.showFilters =false;
    this.showSingleObjDetails = false;
    this.open = "close"
    this.openIndex = undefined;
  }

  open = "close";
  showSingleObjFilterCard(id) {
    this.ShowChart = false;
    this.ChartProductId =0;
    var newval = !this.showSingleObjDetails
    this.showSingleObjDetails = false;
    this.showFilters = false;
    this. showFirstCard = false;
    this.PlanCardheight = "100%";
    this.open = "close"

    if(this.openIndex != id)
    {
        this.open = "open"
        this.openIndex = id;

        this.PlanCardheight = Math.round($(".CardHeight" + this.sanitizeProductID(id)).height()) + 4 + "px";
    }else
    {
      this.openIndex = undefined;
    }
    
    this.showSingleObjDetails = newval;
    
  }

  selectAvgChange(event, value) {
    this.loadAvgUsages = this.loadAvgUsages.map((row) => {
      return row.value === value
        ? this.getAvgValueObject(true, row.value, row.key, row.title, row.des)
        : this.getAvgValueObject(false, row.value, row.key,  row.title, row.des);
    });
    this.avgValueChanged = true;

    sessionStorage.setItem(
      'selectfilterusage',
      value
    );


    if (value !== 'Custom') {
      const sqft_size_range =
        value === '500'
          ? 'lt_1250'
          : value === '1000'
          ? 'btw_1250_2250'
          : 'gt_2250';


          var dwelling_type;
          if(this.questionsArrayData.length != 0)
          {
            var propertyObj = _.findWhere(this.questionsArrayData[0].userResponses, { fieldName: 'property' });
            dwelling_type = propertyObj.fieldValue
      
          }
          else
          {
            dwelling_type = this.residentialService.widthoutQuestionUserRequest["dwellingtype"];
          }



      const body = new HttpParams().append('sqFt', sqft_size_range).append(
        'utilityName',this.getUtilityNameFromQuestionnaire()
  
      ).append(
        'dwellingtype',dwelling_type
  
      );
      this.residentialService
        .getResidentialUsage(body)
        .subscribe((res: any) => {
          this.monthlyUsageArr = res.usage_history;
            this.getRecommendationsPerModifiedAvgUsage(sqft_size_range);
            this.updategraph();
            
            
        });
    }
    this.openCustomAvgUsage(value);
  }

  openCustomAvgUsage(value) {
    this.showOption = false;
    if (value === 'Custom') {
      this.showOption = true;
      // this.openEditUsage();
    }
  }
  getRecommendationsPerModifiedAvgUsage(sqft_size_range) {
    if (this.avgValueChanged) {
      const utilityName = this.getUtilityNameFromQuestionnaire();

      var dwelling_type;
      if(this.questionsArrayData.length != 0)
      {
        var propertyObj = _.findWhere(this.questionsArrayData[0].userResponses, { fieldName: 'property' });
        dwelling_type = propertyObj.fieldValue
  
      }
      else
      {
        dwelling_type = this.residentialService.widthoutQuestionUserRequest["dwellingtype"];
      }
  

  
      const body = new HttpParams()
        .append('sqFt', sqft_size_range)
        .append('utilityName', utilityName)
        .append('stateName', 'TX')
        .append('dwellingtype',dwelling_type)
      this.residentialService
        .getCustomResidentialUsage(body)
        .subscribe((res: any) => {
           this.setAllEnergyProvidersToCompare();
          console.log(res);
        });
    }
  }

  setPaginationDetails(list) {
    if (this.currentPage + 5 >= this.prerecommendation.length)
      return `Showing Plans ${this.prerecommendation.length} of ${list}`;
    else
      return `Showing Plans ${this.currentPage + 1} - ${
        this.currentPage + 5
      } of ${list}`;
  }

  nextRecordSet() {
    this.currentPage = this.currentPage + 5;
    if (this.currentPage <= this.prerecommendation.length) {
      this.setEnergyProvidersRecordSet(this.currentPage);
    }
    else  if (this.currentPage > this.prerecommendation.length) {
      this.currentPage = this.currentPage - 5;
    }
  }

  previousRecordSet() {
    if (this.currentPage > 0) {
      this.currentPage = this.currentPage - 5;
      this.setEnergyProvidersRecordSet(this.currentPage);
    }
  }
  setEnergyProvidersRecordSet(page) {
    let j = page,
      selectedRecords = [];
    for (let i = page; i < this.prerecommendation.length; i++) {
      if (i <= j + 5) selectedRecords.push(this.prerecommendation[i]);
    }
    this.preSelectedRecords = selectedRecords;
  }

  saveChanges() {
    this.checkedList =
      this.checkedListFinal.length > 0
        ? this.checkedListFinal
        : this.checkedList;
    // this.splitData =
    //   this.splitDataFinal.length > 0 ? this.splitDataFinal : this.splitData;
    //if (this.avgValueChanged) this.updategraph();
    this.showAllfilters();
    this.providersCount = this.providersCheckedListCount();
    this.showFilters = false;
    this.setEnergyProvidersRecordSet(this.currentPage);
    const allElem = document.querySelectorAll('.plansummary');
    for (let k = 0; k < allElem.length; k++) {
      if (allElem[k] !== null) {
        allElem[k].classList.add('disableborder');
        allElem[k].firstElementChild.classList.remove('bdrbotmb');
      }
    }

     this.currentPage = 0;
     this.setEnergyProvidersRecordSet(this.currentPage);

     setTimeout(function(){


      window.dispatchEvent(new Event('resize'));

    },100)
  }

  getCheckedListFinal() {
    let total = 0;
    this.checkedListFinal.map((row) => {
      if (row !== undefined) total += 1;
    });
    return total;
  }

  productchange(event, value) {
    const productIndex = this.loadProductTypes.findIndex(
      (row) => row.value === value
    );
    if (productIndex === this.loadProductTypes.length - 1) {
      this.prepaidwb4 = false;
      this.loadProductTypes = this.loadProductTypes.map((row) => {
        return row.value === value
          ? this.getAvgValueObject2(true, row.value, row.key)
          : this.getAvgValueObject2(false, row.value, row.key);
      });
    } else {
      this.prepaidwb4 = true;
      this.loadProductTypes[productIndex].checked =
        !this.loadProductTypes[productIndex].checked;
      this.loadProductTypes[this.loadProductTypes.length - 1].checked = false;
    }

    if(this.ProductTypeSelectList.filter(x => x == value).length == 0)
    {
      this.ProductTypeSelectList.push(value);
    }
    if(this.loadProductTypes[productIndex].checked == false)
    {
      if(this.ProductTypeSelectList.filter(x => x == value).length == 1)
      {
        const index = this.ProductTypeSelectList.indexOf(value);
        if (index > -1) { // only splice array when item is found
          this.ProductTypeSelectList.splice(index, 1); // 2nd parameter means remove one item only
        }
      }

    }

    if(this.ProductTypeSelectList.length != 0 && this.ProductTypeSelectList.filter(x => x == "ShowAll").length == 1)
    {
      this.ProductTypeSelectList = [];
      this.ProductTypeSelectList.push(value);

    }

    sessionStorage.setItem(
      'selectedProductType',
      JSON.stringify(this.ProductTypeSelectList)
    );

    this.setProductTypes();
    if (this.deviceWidth > 768) {
      this.saveChanges();
    }
  }

  getAvgValueObject(checked, value, key, title, des) {
    return {
      checked: checked,
      value: value,
      key: key,
      title:title,
      des:des
    };
  }

  getAvgValueObject2(checked, value,key) {
    return {
      checked: checked,
      value: value,
      key: key

    };
  }

  setProductTypes() {
    this.productTypes = this.loadProductTypes.map((row) => {
      if (row.checked) return row.value;
    });
  }

  setCancellationText(itemValue) {
    return itemValue == null
      ? '$0. There is no cancellation fee associated with this product. You may cancel at any time free of charge. '
      : itemValue.toString().length > 2
      ? `$${itemValue} Note: this fee will not apply if you move and provide a forwarding address verifying the move.`
      : `$${itemValue} per month remaining on contract. Note: this fee will not apply if you move and provide a forwarding address verifying the move.`;
  }

  selectedObject(event, productObj) {
    const allElem = document.querySelectorAll('.plansummary');
    for (let k = 0; k < allElem.length; k++) {
      if (allElem[k].id === event) {
        allElem[k].classList.remove('disableborder');
      } else {
        allElem[k].classList.add('disableborder');
      }
    }
    this.changeIUsageGraphbyProduct(productObj,false);
  }

  setValidatedValue(itemValue) {
    return itemValue === undefined
      ? ''
      : itemValue < 0
      ? `-$${itemValue.toString().substr(1)}`
      : `$${
          typeof itemValue === 'string'
            ? Number(itemValue).toFixed(2)
            : itemValue
        }`;
  }
  setValidatedValue_Pulse(itemValue) {
    return itemValue === undefined
      ? ''
      : itemValue < 0
      ? `-$${itemValue.toString().substr(1)}`
      : `$${
          typeof itemValue === 'string'
            ? Number(itemValue).toFixed(3)
            : itemValue
        }`;
  }
  setValidatedValue_4Change(itemValue) {
    return itemValue === undefined
      ? ''
      : itemValue < 0
      ? `-$${itemValue.toString().substr(1)}`
      : `$${
          typeof itemValue === 'string'
            ? Number(itemValue).toFixed(5)
            : Number(itemValue).toFixed(5)
        }`;
  }
  setValidatedValue_Rhythm(itemValue) {
    return itemValue === undefined
      ? ''
      : itemValue < 0
      ? `-$${itemValue.toString().substr(1)}`
      : `$${
          typeof itemValue === 'string'
            ? Number(itemValue).toFixed(5)
            : Number(itemValue).toFixed(5)
        }`;
  }
  setValidatedTDUValue(itemValue) {
    return itemValue === undefined
      ? ''
      : itemValue < 0
      ? `-$${itemValue.toString().substr(1)}`
      : `$${
          typeof itemValue === 'string'
            ? parseFloat(itemValue).toFixed(6)
            : itemValue.toFixed(6)
        }`;
  }
  SetBaseChargeValidatedValue(itemValue) {
    return typeof Number(itemValue) === 'number' ? Number(itemValue).toString() == "NaN" ? '$0.00'  : `$${itemValue}` : '$0.00';
  }
  setBaseChargeValue(itemValue) {
    itemValue.energy_provider === 'Pulse Power' ||
    itemValue.energy_provider === 'New Power Texas'
      ? this.baseChargeNonUsageValues(itemValue)
      : this.baseChargeUsageValues(itemValue);
  }
  setBaseChargeUsageValuesFor4CE(itemValue) {
    let billCredit, usageValue, baseFee, addUsageValue;
    baseFee = `$${itemValue.base_fee}`;
    if (itemValue.base_fee < 0) {
      baseFee = 0;
      billCredit = itemValue.base_fee;
    }
    if (itemValue.usageTrigger !== 0) {
      usageValue = ` -$${itemValue.base_fee
        .toString()
        .substr(1)} per billing cycle for usage ${itemValue.usageTrigger} kWh`;
    }
    if (itemValue.additionalUsageTrigger !== 0) {
      addUsageValue = ` -$${itemValue.base_fee
        .toString()
        .substr(1)} per billing cycle for usage ${
        itemValue.additionalUsageTrigger
      } kWh`;
    }
    // this.usage4CEObj = {
    //   baseFee: baseFee,
    //   billCredit: billCredit,
    //   usageValue: usageValue,
    //   addUsageValue: addUsageValue,
    // };
  }

  baseChargeNonUsageValues(itemValue) {
    let usageValue;
    if (
      itemValue.minEnergyUsage !== 0 &&
      itemValue.maxEnergyUsage === 99999 &&
      itemValue.billCredit <= 0
    ) {
      usageValue = ` -$${itemValue.billCredit
        .toString()
        .substr(1)} per billing cycle for usage <=${
        itemValue.minEnergyUsage
      } kWh`;
    } else if (
      itemValue.minEnergyUsage !== 0 &&
      itemValue.maxEnergyUsage !== 0
    ) {
      usageValue = ` $${itemValue.billCredit} per billing cycle for usage ${itemValue.minEnergyUsage} - ${itemValue.maxEnergyUsage} kWh`;
    }
    return usageValue;
  }
  baseChargeUsageValues(itemValue) {
    let addUsageValue;

    let usageValue = '0';
    if (itemValue.usage1 != null && itemValue.usage2 === null) {
      usageValue = ` $${itemValue.usage1Charge} per billing cycle for usage >=${itemValue.usage1} kWh`;
    }
    if (itemValue.usage2 != null && itemValue.usage1 != null) {
      usageValue = ` $${itemValue.usage1Charge} per billing cycle for usage ${itemValue.usage1} - ${itemValue.usage2} kWh`;
    }
    if (itemValue.usage3 != null && itemValue.usage4 === null) {
      addUsageValue = ` $${itemValue.usage2Charge} per billing cycle for usage >=$${itemValue.usage3} kWh`;
    }
    if (itemValue.usage3 != null && itemValue.usage4 != null) {
      addUsageValue = ` $${itemValue.usage2Charge} per billing cycle for usage ${itemValue.usage3} - ${itemValue.usage4} kWh`;
    }

    this.usage4CEObj = {
      usageValue: usageValue,
      addUsageValue: addUsageValue,
    };
  }

 
  removeminus(input) {
    var str = "" + input;

    if(str !== null && str != "")
    {
      var matches = str.match(/(\d+)/);
      
      if (matches) {
          return "$"+ matches[0];
      }
   
    }

return "$" + input;
}

// ngAfterContentChecked(): void {

//   this.deviceWidth = window.innerWidth;
//   if(this.deviceWidth < 1025)
//   {
//     this.hideFreezeopt = false;
//     $(".product-list").css("padding-top", 0)
//   }else
//   {
//     this.hideFreezeopt = true;
//     if($('.chartfixedForScroll').length != 0 && $('#chartfixed').css('top') == "0px")
//     {
//       $(".product-list").css("padding-top", $("#chartfixed").height())

//     }else
//     {
//       $(".product-list").css("padding-top", 0)
//     }
//   }

// }

loadScript() {
  let node = document.createElement('script'); // creates the script tag
  node.src = 'https://www.googletagmanager.com/gtag/js?id=AW-10999221905'; // sets the source (insert url in between quotes)
  // node.type = 'text/javascript'; // set the script type
  node.async = true; // makes script run asynchronously
  // node.charset = 'utf-8';
  // append to head of document
  
  document.getElementsByTagName('head')[0].appendChild(node); 

  let script = this._renderer2.createElement('script');
  script.setAttribute('id', 'ChatScript');
  script.text = `
      (function(d, w, c) {
        w.BrevoConversationsID = '649dacacdbc74231a94a3297';
        w[c] = w[c] || function() {
            (w[c].q = w[c].q || []).push(arguments);
        };
        var s = d.createElement('script');
        s.async = true;
        s.src = 'https://conversations-widget.brevo.com/brevo-conversations.js';
        if (d.head) d.head.appendChild(s);
    })(document, window, 'BrevoConversations');
  `;

  const existingScript = document.getElementById("ChatScript");
  if (!existingScript) {
    
  document.getElementsByTagName('head')[0].appendChild(script); 
  }

}

redirectToWebsite(){

  window.location.href = this.app_url;

}


checkEnergyProvidersApiPlanStatus(res, productID) {
  if (
    res.length > 0 &&
    productID !== res[0].ProductID &&
    this.residentialService.validateCreatedDateTime(res[0].createdDate)
  ) {
    this.assignNewEnergyProvidersRates();
  } else {
    this.getUserDetails();
  }
}

  getUserDetails() {
    
    this.assignSelectedSignupProduct();
    this.saveRecommendedSelectedProduct();


    sessionStorage.setItem(
      'recommendationsSelected',
      JSON.stringify(this.residentialService.recommendations)
    );


    const hg_accountId = window.location.href.split('/').pop(),
      body = new HttpParams().append('hg_accountId', this.recommendationService.hg_accountId);
    this.http
      .get(this.url + '/getHgUser', { params: body })
      .subscribe((res: any) => {
        const result = res;
        if (!_.isEmpty(result)) {
          this.residentialService.user = result.user
            ? result.user
            : this.residentialService.user;
        }
        if (
          this.residentialService.user &&
          //this.residentialService.user.emailId &&
          (!_.isEmpty(this.residentialService.user.accountId) ||
            !_.isEmpty(this.residentialService.user._id))
        ) {
          this.validateNewEnergyProvider();
        } else {
          sessionStorage.setItem('zipCode', this.residentialService.zipCode);
          this.router.navigate(['signup']);
        }
      });
  }

  validateNewEnergyProvider() {
    if (this.residentialService.user) {
      this.loadEnergyProviders[
        this.recommendationService.signupProduct.energy_provider ===
        '4Change Energy'
          ? `${this.recommendationService.signupProduct.energy_provider
              .replace(/\s/g, '')
              .slice(1)}4`
          : this.recommendationService.signupProduct.energy_provider.replace(
              /\s/g,
              ''
            )
      ]();
    }
  }
  navigatePrePaidEnergyProvider() {
    this.residentialService.recommendations = this.recommendations;
    this.router.navigate([
      'prepaidoption',
      this.recommendationService.hg_accountId,
    ]);
  }

  navigateOtherEnergyProviders() {
    this.residentialService.recommendations = this.recommendations;
    this.router.navigate([
      'signuporder',
      this.recommendationService.hg_accountId,
    ]);
  }

  navigateBulbEnergyProvider() {
    window.location.href = `https://join.bulb.com/?utm_source=HonestGorilla&utm_medium=pcw&utm_campaign=HonestGorilla`;
  }


    assignSelectedSignupProduct() {
      if (!_.isEmpty(this.recommendationService.signupProduct)) {
        this.selectedProduct = this.recommendationService.signupProduct;
        sessionStorage.setItem(
          'signupProduct',
          JSON.stringify(this.selectedProduct)
        );
      } else {
        this.recommendationService.signupProduct = JSON.parse(
          sessionStorage.getItem('signupProduct')
        );
        this.selectedProduct = JSON.parse(
          sessionStorage.getItem('signupProduct')
        );
      }
    }

    saveRecommendedSelectedProduct() {
      sessionStorage.setItem('noUserId', this.recommendationService.hg_accountId);
      const hgAccountId = {
        hg_accountId: this.recommendationService.hg_accountId,
        userResponses: JSON.parse(sessionStorage.getItem('userResponse')),
      };
      this.residentialService
        .postSelectedProductAPI({
          ...this.recommendationService.signupProduct,
          ...hgAccountId,
        })
        .subscribe((res: any) => {});
    }


  getMinMonth(usageList: {
    month: string;
    total_energy_charge_per_month: number;
    avg_energy_charge_per_KWH: number;
  }[]): { month: string; total_energy_charge_per_month: number; avg_energy_charge_per_KWH: number } | null {
    if (!usageList || usageList.length === 0) return null;

    return usageList.reduce((min, current) =>
      current.total_energy_charge_per_month < min.total_energy_charge_per_month ? current : min
    );
}

   getMaxMonth(usageList: {
  month: string;
  total_energy_charge_per_month: number;
  avg_energy_charge_per_KWH: number;
}[]): { month: string; total_energy_charge_per_month: number; avg_energy_charge_per_KWH: number } | null {
  if (!usageList || usageList.length === 0) return null;

  return usageList.reduce((max, current) =>
    current.total_energy_charge_per_month > max.total_energy_charge_per_month ? current : max
  );
}

  getMonthShortCode(fullMonth: string): string {
  const monthMap: { [key: string]: string } = {
    January: 'Jan',
    February: 'Feb',
    March: 'Mar',
    April: 'Apr',
    May: 'May',
    June: 'Jun',
    July: 'Jul',
    August: 'Aug',
    September: 'Sep',
    October: 'Oct',
    November: 'Nov',
    December: 'Dec'
  };

  return monthMap[fullMonth] || fullMonth;
}


getAvgRates(newValue)
{
  var newArray = [];
  
    for (let j = 0; j < newValue.length; j++) {
          var r = {
          point: newValue[j].point,
          color: '#ED1976',
          avg_energy_charge_per_KWH: newValue[j].avg_energy_charge_per_KWH,
          y: Number((newValue[j].avg_energy_charge_per_KWH * 100 ).toFixed(1)),
          energy_charge_per_month: newValue[j].energy_charge_per_month,
          usage: newValue[j].usage,
          }

          newArray.push(r)

    }
        
 
  return newArray;
}

sanitizeProductID(id: any): string {
  if (!id) return '';
  return String(id).replace(/\|\|/g, '').replace(/\s+/g, ''); // Remove all occurrences of ||
}

getRenewableValue(value: any): number {
  if (value == null || value === '') return 0;
  return +value; // converts string/number to number
}
// getHeight(id,ProductId)
// {
//   if(this.open == 'open' && ProductId === this.openIndex)
//   {
//     this.height = Math.round($("#" + id).height()) + "";

//   }

//   this.height = "0";
// }

}

// function CallTrackFunction(energy_provider, product_key, terms, usageObj1, usageObj2, usageObj3,zipcode,utility_name ) {
  
//   $.fn.sendinblue.track(

//     'CompareProduct', "" ,
  
//     {
  
//       "REP": singleObj.energy_provider,
  
//       "Product_Name" : singleObj.product_key,
  
//       "Contract_Term" : singleObj.terms,
  
//       "Price_500" :  (singleObj.usageObj[0].avg_charge * 100).toFixed(1),
  
//       "Price_1000" :(singleObj.usageObj[1].avg_charge * 100).toFixed(1),
  
//       "Price_2000" : (singleObj.usageObj[2].avg_charge * 100).toFixed(1),
  
//       "Zip" : zipcode,
  
//       "TDSP" : singleObj.utility_name
  
//     }
  
//   );
// }


// function callJQueryFunction() {
//   // Call the jQuery function
//   $.fn.myJQueryFunction();
// }

